/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/common.js":
/*!***********************!*\
  !*** ./src/common.js ***!
  \***********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   customFetchWithTimeout: function() { return /* binding */ customFetchWithTimeout; },
/* harmony export */   dateFormatCommon: function() { return /* binding */ dateFormatCommon; },
/* harmony export */   getClientHourClock: function() { return /* binding */ getClientHourClock; },
/* harmony export */   getCookie: function() { return /* binding */ getCookie; },
/* harmony export */   getHourlyTimestamp: function() { return /* binding */ getHourlyTimestamp; },
/* harmony export */   getLang: function() { return /* binding */ getLang; },
/* harmony export */   getObjectValues: function() { return /* binding */ getObjectValues; },
/* harmony export */   getUAClientHourClock: function() { return /* binding */ getUAClientHourClock; },
/* harmony export */   getUALang: function() { return /* binding */ getUALang; },
/* harmony export */   getUriPathLang: function() { return /* binding */ getUriPathLang; },
/* harmony export */   getUrlParamByName: function() { return /* binding */ getUrlParamByName; },
/* harmony export */   isArrayAndNotEmpty: function() { return /* binding */ isArrayAndNotEmpty; },
/* harmony export */   isBrowser: function() { return /* binding */ isBrowser; },
/* harmony export */   listDateFormatCommon: function() { return /* binding */ listDateFormatCommon; },
/* harmony export */   optionsValidate: function() { return /* binding */ optionsValidate; },
/* harmony export */   padStart: function() { return /* binding */ padStart; }
/* harmony export */ });
/* harmony import */ var _enum_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./enum.js */ "./src/enum.js");
/* harmony import */ var _defaultConfig_template_config_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./defaultConfig/template-config.js */ "./src/defaultConfig/template-config.js");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


// 兜底配置

var LANG_PARAM = _objectSpread({}, _enum_js__WEBPACK_IMPORTED_MODULE_0__.LANG_PARAM);

// 语言不存在
var LANG_EOF = -1;

// 手动实现 padStart 兼容ie
var padStart = function padStart(str, targetLength, padChar) {
  if (str.length >= targetLength) {
    return str;
  }
  padChar = padChar || ' ';
  return padStart(padChar + str, targetLength, padChar);
};

// 手动实现 Object.values 兼容ie
var getObjectValues = function getObjectValues(obj) {
  var keys = Object.keys(obj);
  var values = [];
  for (var i = 0; i < keys.length; i++) {
    // 使用hasOwnProperty来确保属性是对象本身的属性而不是原型链上的
    if (Object.prototype.hasOwnProperty.call(obj, keys[i])) {
      values.push(obj[keys[i]]);
    }
  }
  return values;
};
var isArrayAndNotEmpty = function isArrayAndNotEmpty(arr) {
  return Array.isArray(arr) && arr.length > 0;
};

// 获取当前小时时间戳
var getHourlyTimestamp = function getHourlyTimestamp() {
  // 获取当前时间
  var now = new Date();
  var thisHour = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours());
  // 返回当前小时开始时的时间戳
  return thisHour.getTime();
};

// 是否在浏览器中运行
var isBrowser = function isBrowser() {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    return true;
  }
  return false;
};

// fetch 超时封装
var customFetchWithTimeout = function customFetchWithTimeout(url, timeout) {
  return new Promise(function (resolve, reject) {
    // 开始执行 fetch 请求
    fetch(url)
    // 请求成功时调用 resolve
    .then(resolve)
    // 请求失败时调用 reject
    ["catch"](reject);

    // 设置超时回调，超时则抛出异常
    setTimeout(function () {
      reject(new Error('fetch request timeout'));
    }, timeout);
  });
};

/**
 * 获取URL中给定参数的值
 * @param {string} name - 要检索的参数名称。
 * @returns {string} 返回参数值，如果参数不存在则返回null，如果参数存在但无值返回空字符串。
 */
var getUrlParamByName = function getUrlParamByName(paramName) {
  // 不是浏览器环境，返回空字符串
  if (!isBrowser()) {
    return '';
  }
  var url = window.location.href;
  if (!url) {
    return '';
  }
  var regex = new RegExp('[?&]' + paramName + '=([^&#]*)');
  var results = regex.exec(url);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/**
 * 根据 locale 获取语言
 * @param {string} locale
 * @returns {Number} 返回语言
 */
function getLangByLocale() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  locale = typeof locale === 'string' ? locale.toLowerCase() : '';
  var _iterator = _createForOfIteratorHelper(LANG_PARAM.SUPPORT_LANG),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var supportLang = _step.value;
      if (supportLang === LANG_PARAM.LOCALE_LANG_CODE[locale]) {
        return supportLang;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return LANG_EOF;
}

// 判断语言是否为支持的语言
function isSupportLang(lang) {
  if (!lang && lang !== 0) {
    return false;
  }
  return LANG_PARAM.SUPPORT_LANG.indexOf(+lang) > -1;
}

/**
 * 获取客户端UA语言环境 CliLang
 *
 * @param {*} userAgent
 * @returns
 */
var getUALang = function getUALang() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var lang = LANG_EOF;
  var matchResult = ('' + userAgent).match(/CliLang\/([\w|-]*)/i);
  if (matchResult && matchResult.length >= 2) {
    lang = getLangByLocale(matchResult[1].toLowerCase() || '');
  }
  return lang;
};

/**
 * 获取客户端UA中的小时制参数 ClientHourClock
 *
 * @param {*} userAgent
 * @returns
 */
var getUAClientHourClock = function getUAClientHourClock() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var hourClock = '';
  var matchResult = ('' + userAgent).match(/ClientHourClock\/([\w|-]*)/i);
  if (matchResult && matchResult.length >= 2) {
    hourClock = matchResult[1];
  }
  return hourClock;
};

/**
 * 获取新的url路径上的语言设置，eg: https://www.moomoo.com/sg/hant/about
 *               英文         繁体中文                 简体中文
 * moomoo us官网   /           /hant                   /hans
 * moomoo sg官网   /sg         /sg/hant                /sg/hans
 * futuhk 大陆官网  /cn/en         /cn/hant             /cn
 * futuhk 香港官网  /en           /                     /hans
 * @param {string} [uri='']
 * @param {{PATH_AREA: string[], PATH_LANG: string[] }} [matchs = {}]
 * @returns
 */
var getUriPathLang = function getUriPathLang() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var pathList = (pathname || '').split('/');
  var pathOne = pathList[1];
  var pathTwo = pathList[2];
  if (LANG_PARAM.PATH_AREA.indexOf(pathOne) > -1) {
    if (LANG_PARAM.PATH_LANG.indexOf(pathTwo) > -1) {
      return LANG_PARAM.PATH_LANG_MAP[pathTwo];
    }
  } else if (LANG_PARAM.PATH_LANG.indexOf(pathOne) > -1) {
    return LANG_PARAM.PATH_LANG_MAP[pathOne];
  }
  return LANG_EOF;
};

// 获取 cookie 参数
var getCookie = function getCookie(name) {
  // 将cookie字符串以"; "为分隔符转换为数组
  var cookieArr = document.cookie.split('; ') || [];
  // 遍历cookie数组，寻找所需的cookie值
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split('='); // 将每个cookie键值对以"="分隔
    if (name === cookiePair[0]) {
      return decodeURIComponent(cookiePair[1]); // 返回值，并对其进行URL解码
    }
  }
  // 如果没有找到，返回null
  return null;
};

// 获取语言
var getLang = function getLang(langParam) {
  if (langParam) {
    LANG_PARAM = langParam;
  }
  // 不是浏览器环境，返回英文
  if (!isBrowser()) {
    return _enum_js__WEBPACK_IMPORTED_MODULE_0__.LANG_CODE.LANG_EN;
  }
  var lang = LANG_EOF;
  try {
    // 1. 从 UserAgent 中获取
    var userAgent = window.navigator.userAgent;
    if (userAgent) {
      lang = getUALang(userAgent);
    }
    var pathname = window.location.pathname;
    // 2. url路径中获取
    if (!isSupportLang(lang) && pathname) {
      lang = getUriPathLang(pathname);
    }
    // 3. url参数中获取 lang / clientlang
    if (!isSupportLang(lang)) {
      var locale = getUrlParamByName('lang');
      lang = getLangByLocale(locale || '');
    }
    if (!isSupportLang(lang)) {
      lang = getUrlParamByName('clientlang');
    }
    // 4. cookie 中获取 locale
    if (!isSupportLang(lang)) {
      var _locale = getCookie('locale');
      if (_locale) {
        lang = getLangByLocale(_locale || '');
      }
    }
    // 5. 兜底英文
    if (!isSupportLang(lang)) {
      lang = _enum_js__WEBPACK_IMPORTED_MODULE_0__.LANG_CODE.LANG_EN;
    }
  } catch (error) {
    // 异常：兜底英文
    lang = _enum_js__WEBPACK_IMPORTED_MODULE_0__.LANG_CODE.LANG_EN;
  }
  return LANG_PARAM.LANG_MAP[+lang];
};

// 获取小时制 12/24
var getClientHourClock = function getClientHourClock() {
  // 不是浏览器环境，返回24小时制
  if (!isBrowser()) {
    return _enum_js__WEBPACK_IMPORTED_MODULE_0__.CLIENT_HOUR_CLOCK.HOUR_24;
  }
  try {
    // 1. 从 UserAgent 中获取
    var userAgent = window.navigator.userAgent;
    var hourClock = '';
    if (userAgent) {
      hourClock = getUAClientHourClock(userAgent);
    }
    // 2. ua里获取不到，则从url中读取
    if (!hourClock) {
      hourClock = getUrlParamByName('client_hour_clock');
    }
    // 等于12 返回12，其他情况返回24
    if (+hourClock === _enum_js__WEBPACK_IMPORTED_MODULE_0__.CLIENT_HOUR_CLOCK.HOUR_12) {
      return _enum_js__WEBPACK_IMPORTED_MODULE_0__.CLIENT_HOUR_CLOCK.HOUR_12;
    } else {
      // 不是12，则都默认为24
      return _enum_js__WEBPACK_IMPORTED_MODULE_0__.CLIENT_HOUR_CLOCK.HOUR_24;
    }
  } catch (error) {
    // 异常：兜底24小时制
    return _enum_js__WEBPACK_IMPORTED_MODULE_0__.CLIENT_HOUR_CLOCK.HOUR_24;
  }
};
var dateFormatCommon = function dateFormatCommon(options, i18nTemplate) {
  try {
    var dateTemplateArr = options.dateTemplateArr,
      clientHourClock = options.clientHourClock;
    var timestamps = options.timestamps;
    var timeZone = options.timeZone;
    var _options$lang = options.lang,
      lang = _options$lang === void 0 ? -1 : _options$lang;
    if (!i18nTemplate) {
      // 获取不到模板配置时，使用兜底配置
      i18nTemplate = _defaultConfig_template_config_js__WEBPACK_IMPORTED_MODULE_1__["default"];
    }
    timestamps = +timestamps;
    // timestamps 必须为正整数
    if (!timestamps || timestamps < 0 || !/^\d+$/.test(timestamps.toString())) {
      throw new Error('timestamps must be a positive integerz.');
    }
    // 设置支持的语言
    if (lang === -1 || i18nTemplate.LANG_PARAM.SUPPORT_LANG.indexOf(lang) < 0) {
      // 没有传入语言，或者传入的语言不在支持的语言中，则自动获取
      lang = getLang(i18nTemplate.LANG_PARAM);
    }
    // 将时间戳转换为js日期对象
    var date = new Date(timestamps);
    // 先保存毫秒
    var millisecond = padStart(date.getMilliseconds().toString(), 3, '0');

    // 将时间转为时区对应的时间
    var formatOptions = {};

    // 无时区时默认获取当前时区
    if (!timeZone && (typeof Intl === "undefined" ? "undefined" : _typeof(Intl)) === 'object' && typeof Intl.DateTimeFormat === 'function' && typeof Intl.DateTimeFormat().resolvedOptions === 'function') {
      timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    }
    if (timeZone) {
      formatOptions.timeZone = timeZone;
    }
    var timeString = date.toLocaleString('en-US', formatOptions);
    var currentDate = new Date(timeString);

    // dateTemplateArr所有数值进行'位或'
    var dateSum = dateTemplateArr.reduce(function (accumulatedValue, currentValue) {
      return accumulatedValue | currentValue;
    }, 0);
    // 读取 url 中的 client_hour_clock
    var client_hour_clock = clientHourClock || getClientHourClock();
    // 获取包含 年/月/日/时/分/秒/星期 等属性的时间对象
    var dateParts = {
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      day: currentDate.getDate(),
      // 星期根据语言获取
      week: currentDate.getDay(),
      hour: currentDate.getHours(),
      minute: currentDate.getMinutes(),
      millisecond: millisecond,
      second: currentDate.getSeconds(),
      hourClock: '',
      timeZoneText: ''
    };

    // hour 处理
    if (_enum_js__WEBPACK_IMPORTED_MODULE_0__.DATE_ELEMENT.HOUR & dateSum) {
      // 12小时制处理
      if (+client_hour_clock === _enum_js__WEBPACK_IMPORTED_MODULE_0__.CLIENT_HOUR_CLOCK.HOUR_12) {
        dateParts.hourClock = dateParts.hour >= 12 ? i18nTemplate[i18nTemplate.TEXT_MAP.HOUR.PM][lang] : i18nTemplate[i18nTemplate.TEXT_MAP.HOUR.AM][lang];
        if (dateParts.hour === 0 || dateParts.hour === 12) {
          // 特殊情况：12小时制时 0点和12点，显示为12点
          dateParts.hour = 12;
        } else {
          dateParts.hour = dateParts.hour > 12 ? dateParts.hour - 12 : dateParts.hour;
        }
      }
    }
    if (_enum_js__WEBPACK_IMPORTED_MODULE_0__.DATE_ELEMENT.TIMEZONE & dateSum) {
      dateParts.timeZoneText = timeZone && i18nTemplate.TIMEZONE_MAP[timeZone] ? i18nTemplate[i18nTemplate.TIMEZONE_MAP[timeZone]][lang] : '';
    }
    var i18nId = 0;

    // 区分英区，如果时区在英区列表中，先读取英区文案id，读取不到则使用美区
    if (timeZone && i18nTemplate.UK_AREA_LIST && i18nTemplate.UK_AREA_LIST.indexOf(timeZone) > -1) {
      // 如果读取不到，默认从24小时制读取
      i18nId = i18nTemplate.TEMPLATE_MAP.UK[client_hour_clock][dateSum] || i18nTemplate.TEMPLATE_MAP.UK[_enum_js__WEBPACK_IMPORTED_MODULE_0__.CLIENT_HOUR_CLOCK.HOUR_24][dateSum];
    }
    // 默认使用美区文案id
    if (!i18nId) {
      // 如果读取不到，默认从24小时制读取
      i18nId = i18nTemplate.TEMPLATE_MAP.US[client_hour_clock][dateSum] || i18nTemplate.TEMPLATE_MAP.US[_enum_js__WEBPACK_IMPORTED_MODULE_0__.CLIENT_HOUR_CLOCK.HOUR_24][dateSum];
    }

    // 获取语言对应的模板
    var formatTemplate = i18nTemplate[i18nId][lang];
    if (!formatTemplate) {
      throw new Error('formatTemplate is empty.');
    }

    // 替换年、月、日、小时、分钟、秒、星期
    var dateStr = formatTemplate
    // 年
    .replace(/YYYY/g, dateParts.year)
    // 日 01-31
    .replace(/DD/g, padStart(dateParts.day.toString(), 2, '0'))
    // 日 1-31
    .replace(/D/g, dateParts.day)
    // 时
    .replace(/HH/g, padStart(dateParts.hour.toString(), 2, '0'))
    // 分
    .replace(/mm/g, padStart(dateParts.minute.toString(), 2, '0'))
    // 秒
    .replace(/ss/g, padStart(dateParts.second.toString(), 2, '0'))
    // 毫秒
    .replace(/SSS/g, dateParts.millisecond)
    // 12小时制
    .replace(/HourClock/g, dateParts.hourClock)
    // 星期
    .replace(/EEEE/g, i18nTemplate[i18nTemplate.TEXT_MAP.WEEK[dateParts.week]][lang])
    // 月
    .replace(/MMMM/g, i18nTemplate[i18nTemplate.TEXT_MAP.MONTH[dateParts.month]][lang])
    // 时区
    .replace(/TimeZone/g, dateParts.timeZoneText || '')
    // 连续多个空格替换为一个空格
    .replace(/\s+/g, ' ')
    // 去掉字符串前后空格
    .replace(/^\s+|\s+$/g, '');
    return dateStr;
  } catch (error) {
    console.error('[dateFormatCommon error]: ', error);
    return '';
  }
};

// 参数校验: dateTemplateArr
var optionsValidate = function optionsValidate(options) {
  var dateTemplateArr = options.dateTemplateArr;

  // dateTemplateArr 必须为数组，且长度大于0
  if (!dateTemplateArr || !isArrayAndNotEmpty(dateTemplateArr)) {
    throw new Error('dateTemplateArr must be an array of length greater than 0.');
  }

  // 将所有有效的模板值放入一个集合中
  var validTemplates = [].concat(getObjectValues(_enum_js__WEBPACK_IMPORTED_MODULE_0__.TEMPLATE_YMD)).concat(getObjectValues(_enum_js__WEBPACK_IMPORTED_MODULE_0__.TEMPLATE_HMS)).concat(getObjectValues(_enum_js__WEBPACK_IMPORTED_MODULE_0__.TEMPLATE_WEEK)).concat(getObjectValues(_enum_js__WEBPACK_IMPORTED_MODULE_0__.TEMPLATE_TIMEZONE));

  // 检查 dateTemplateArr 数组是否仅包含有效的模板
  if (!dateTemplateArr.every(function (tpl) {
    return validTemplates.indexOf(tpl) > -1;
  })) {
    throw new Error('dateTemplateArr contains invalid template elements.');
  }
};

// 参数校验: dateTemplateArr
var listDateFormatCommon = function listDateFormatCommon(options, i18nTemplate) {
  var dataList = options.dataList,
    attrNameList = options.attrNameList;
  // 判断是否为数组，且长度大于0，否则返回原dataList
  if (!dataList || !attrNameList || !isArrayAndNotEmpty(dataList) || !isArrayAndNotEmpty(attrNameList)) {
    return dataList;
  }
  attrNameList.forEach( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(attrName) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dataList.forEach(function (item) {
              if (item[attrName]) {
                // 不污染原属性，新增属性，属性名在原属性名前加上 f_
                item["f_".concat(attrName)] = dateFormatCommon(_objectSpread(_objectSpread({}, options), {}, {
                  timestamps: item[attrName]
                }), i18nTemplate);
              }
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  return dataList;
};

/***/ }),

/***/ "./src/defaultConfig/template-config.js":
/*!**********************************************!*\
  !*** ./src/defaultConfig/template-config.js ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  "254345": {
    "0": "YYYY/MMMM/DD",
    "1": "YYYY/MMMM/DD",
    "2": "MMMM D, YYYY",
    "5": "YYYY/MMMM/DD",
    "7": "MMMM D, YYYY"
  },
  "254346": {
    "0": "HH:mm:ss",
    "1": "HH:mm:ss",
    "2": "HH:mm:ss",
    "5": "HH:mm:ss",
    "7": "HH:mm:ss"
  },
  "254347": {
    "0": "YYYY/MMMM/DD HH:mm:ss",
    "1": "YYYY/MMMM/DD HH:mm:ss",
    "2": "MMMM D, YYYY HH:mm:ss",
    "5": "YYYY/MMMM/DD HH:mm:ss",
    "7": "MMMM D, YYYY HH:mm:ss"
  },
  "254348": {
    "0": "YYYY/MMMM/DD EEEE HH:mm:ss",
    "1": "YYYY/MMMM/DD EEEE HH:mm:ss",
    "2": "EEEE, MMMM D, YYYY HH:mm:ss",
    "5": "YYYY/MMMM/DD(EEEE) HH:mm:ss",
    "7": "EEEE, MMMM D, YYYY HH:mm:ss"
  },
  "254349": {
    "0": "YYYY/MMMM/DD EEEE HH:mm:ss (TimeZone)",
    "1": "YYYY/MMMM/DD EEEE HH:mm:ss (TimeZone)",
    "2": "EEEE, MMMM D, YYYY HH:mm:ss TimeZone",
    "5": "YYYY/MMMM/DD(EEEE) HH:mm:ss TimeZone",
    "7": "EEEE, MMMM D, YYYY HH:mm:ss TimeZone"
  },
  "254350": {
    "0": "HourClockHH:mm:ss",
    "1": "HourClockHH:mm:ss",
    "2": "HH:mm:ss HourClock",
    "5": "HourClockHH:mm:ss",
    "7": "HH:mm:ss HourClock"
  },
  "254351": {
    "0": "YYYY/MMMM/DD HourClockHH:mm:ss",
    "1": "YYYY/MMMM/DD HourClockHH:mm:ss",
    "2": "MMMM D, YYYY HH:mm:ss HourClock",
    "5": "YYYY/MMMM/DD HourClockHH:mm:ss",
    "7": "MMMM D, YYYY HH:mm:ss HourClock"
  },
  "254352": {
    "0": "YYYY/MMMM/DD EEEE HourClockHH:mm:ss",
    "1": "YYYY/MMMM/DD EEEE HourClockHH:mm:ss",
    "2": "EEEE, MMMM D, YYYY HH:mm:ss HourClock",
    "5": "YYYY/MMMM/DD(EEEE) HourClockHH:mm:ss",
    "7": "EEEE, MMMM D, YYYY HH:mm:ss HourClock"
  },
  "254353": {
    "0": "YYYY/MMMM/DD EEEE HourClockHH:mm:ss (TimeZone)",
    "1": "YYYY/MMMM/DD EEEE HourClockHH:mm:ss (TimeZone)",
    "2": "EEEE, MMMM D, YYYY HH:mm:ss HourClock TimeZone",
    "5": "YYYY/MMMM/DD(EEEE) HourClockHH:mm:ss TimeZone",
    "7": "EEEE, MMMM D, YYYY HH:mm:ss HourClock TimeZone"
  },
  "254354": {
    "0": "星期日",
    "1": "星期日",
    "2": "Sun",
    "5": "日",
    "7": "Sun"
  },
  "254355": {
    "0": "星期一",
    "1": "星期一",
    "2": "Mon",
    "5": "月",
    "7": "Mon"
  },
  "254356": {
    "0": "星期二",
    "1": "星期二",
    "2": "Tue",
    "5": "火",
    "7": "Tue"
  },
  "254357": {
    "0": "星期三",
    "1": "星期三",
    "2": "Wed",
    "5": "水",
    "7": "Wed"
  },
  "254358": {
    "0": "星期四",
    "1": "星期四",
    "2": "Thu",
    "5": "木",
    "7": "Thu"
  },
  "254359": {
    "0": "星期五",
    "1": "星期五",
    "2": "Fri",
    "5": "金",
    "7": "Fri"
  },
  "254360": {
    "0": "星期六",
    "1": "星期六",
    "2": "Sat",
    "5": "土",
    "7": "Sat"
  },
  "254361": {
    "0": "01",
    "1": "01",
    "2": "Jan",
    "5": "01",
    "7": "Jan"
  },
  "254362": {
    "0": "02",
    "1": "02",
    "2": "Feb",
    "5": "02",
    "7": "Feb"
  },
  "254363": {
    "0": "03",
    "1": "03",
    "2": "Mar",
    "5": "03",
    "7": "Mar"
  },
  "254364": {
    "0": "04",
    "1": "04",
    "2": "Apr",
    "5": "04",
    "7": "Apr"
  },
  "254365": {
    "0": "05",
    "1": "05",
    "2": "May",
    "5": "05",
    "7": "May"
  },
  "254366": {
    "0": "06",
    "1": "06",
    "2": "Jun",
    "5": "06",
    "7": "Jun"
  },
  "254367": {
    "0": "07",
    "1": "07",
    "2": "Jul",
    "5": "07",
    "7": "Jul"
  },
  "254368": {
    "0": "08",
    "1": "08",
    "2": "Aug",
    "5": "08",
    "7": "Aug"
  },
  "254369": {
    "0": "09",
    "1": "09",
    "2": "Sep",
    "5": "09",
    "7": "Sep"
  },
  "254370": {
    "0": "10",
    "1": "10",
    "2": "Oct",
    "5": "10",
    "7": "Oct"
  },
  "254371": {
    "0": "11",
    "1": "11",
    "2": "Nov",
    "5": "11",
    "7": "Nov"
  },
  "254372": {
    "0": "12",
    "1": "12",
    "2": "Dec",
    "5": "12",
    "7": "Dec"
  },
  "254373": {
    "0": "上午",
    "1": "上午",
    "2": "AM",
    "5": "午前",
    "7": "AM"
  },
  "254374": {
    "0": "下午",
    "1": "下午",
    "2": "PM",
    "5": "午後",
    "7": "PM"
  },
  "254375": {
    "0": "北京",
    "1": "北京",
    "2": "CST",
    "5": "CST",
    "7": "CST"
  },
  "254376": {
    "0": "香港",
    "1": "香港",
    "2": "HKT",
    "5": "HKT",
    "7": "HKT"
  },
  "254377": {
    "0": "美东",
    "1": "美東",
    "2": "ET",
    "5": "ET",
    "7": "ET"
  },
  "254378": {
    "0": "美中",
    "1": "美中",
    "2": "CT",
    "5": "CT",
    "7": "CT"
  },
  "254379": {
    "0": "柏林",
    "1": "柏林",
    "2": "CET",
    "5": "CET",
    "7": "CET"
  },
  "254380": {
    "0": "伦敦",
    "1": "倫敦",
    "2": "GMT",
    "5": "GMT",
    "7": "GMT"
  },
  "254381": {
    "0": "米兰",
    "1": "米蘭",
    "2": "CET",
    "5": "CET",
    "7": "CET"
  },
  "254382": {
    "0": "台北",
    "1": "台北",
    "2": "CST",
    "5": "CST",
    "7": "CST"
  },
  "254383": {
    "0": "新加坡",
    "1": "新加坡",
    "2": "SGT",
    "5": "SGT",
    "7": "SGT"
  },
  "254384": {
    "0": "巴黎",
    "1": "巴黎",
    "2": "CET",
    "5": "CET",
    "7": "CET"
  },
  "254385": {
    "0": "阿姆斯特丹",
    "1": "阿姆斯特丹",
    "2": "CET",
    "5": "CET",
    "7": "CET"
  },
  "254386": {
    "0": "里斯本",
    "1": "里斯本",
    "2": "GMT",
    "5": "GMT",
    "7": "GMT"
  },
  "254387": {
    "0": "布鲁塞尔",
    "1": "布魯塞爾",
    "2": "CET",
    "5": "CET",
    "7": "CET"
  },
  "254388": {
    "0": "首尔",
    "1": "首爾",
    "2": "KST",
    "5": "KST",
    "7": "KST"
  },
  "254389": {
    "0": "悉尼",
    "1": "悉尼",
    "2": "AET",
    "5": "AET",
    "7": "AET"
  },
  "254390": {
    "0": "东京",
    "1": "東京",
    "2": "JST",
    "5": "JST",
    "7": "JST"
  },
  "254391": {
    "0": "马来西亚",
    "1": "馬來西亞",
    "2": "MYT",
    "5": "MYT",
    "7": "MYT"
  },
  "254454": {
    "0": "MMMM/DD HH:mm",
    "1": "MMMM/DD HH:mm",
    "2": "MMMM D HH:mm",
    "5": "MMMM/DD HH:mm",
    "7": "MMMM D HH:mm"
  },
  "254895": {
    "0": "{\"TEMPLATE_MAP\":{\"US\":{\"12\":{\"1\":255016,\"2\":255017,\"3\":255019,\"4\":255018,\"6\":255021,\"7\":254345,\"8\":254981,\"16\":254982,\"24\":254996,\"30\":255024,\"31\":255076,\"32\":254983,\"56\":254350,\"62\":255036,\"63\":254351,\"64\":254984,\"120\":255001,\"126\":255040,\"127\":255094,\"128\":255003,\"131\":255020,\"134\":255041,\"135\":255095,\"152\":255006,\"158\":255046,\"159\":255098,\"184\":255010,\"190\":255053,\"191\":254352,\"248\":255014,\"254\":255066,\"255\":255102,\"256\":254979,\"262\":255826,\"280\":254994,\"286\":255023,\"287\":255073,\"312\":254997,\"318\":255031,\"319\":255089,\"376\":255000,\"382\":255037,\"383\":255091,\"408\":255005,\"414\":255044,\"415\":255097,\"440\":255009,\"446\":255051,\"447\":254353,\"504\":255013,\"510\":255063,\"511\":255101},\"24\":{\"1\":255016,\"2\":255017,\"3\":255019,\"4\":255018,\"6\":255021,\"7\":254345,\"8\":254980,\"16\":254982,\"24\":254995,\"30\":254454,\"31\":255078,\"32\":254983,\"56\":254346,\"62\":255035,\"63\":254347,\"64\":254984,\"120\":255002,\"126\":255039,\"127\":255093,\"128\":255003,\"131\":255020,\"134\":255041,\"135\":255095,\"152\":255007,\"158\":255048,\"159\":255099,\"184\":255011,\"190\":255057,\"191\":254348,\"248\":255015,\"254\":255068,\"255\":255103,\"256\":254979,\"262\":255825,\"263\":256073,\"280\":254993,\"286\":255022,\"287\":255070,\"312\":254998,\"318\":255032,\"319\":255085,\"376\":254999,\"382\":255038,\"383\":255092,\"408\":255004,\"414\":255042,\"415\":255096,\"440\":255008,\"446\":255050,\"447\":254349,\"504\":255012,\"510\":255061,\"511\":255100}},\"UK\":{\"12\":{\"6\":255105,\"7\":255131,\"30\":255108,\"31\":255134,\"62\":255112,\"63\":255138,\"126\":255116,\"127\":255142,\"134\":255118,\"135\":255144,\"158\":255121,\"159\":255147,\"190\":255126,\"191\":255151,\"254\":255130,\"255\":255155,\"286\":255107,\"287\":255133,\"318\":255111,\"319\":255137,\"382\":255115,\"383\":255141,\"414\":255120,\"415\":255146,\"446\":255124,\"447\":255150,\"510\":255127,\"511\":255154},\"24\":{\"6\":255105,\"7\":255131,\"30\":255109,\"31\":255135,\"62\":255113,\"63\":255139,\"126\":255117,\"127\":255143,\"134\":255118,\"135\":255144,\"158\":255122,\"159\":255148,\"190\":255125,\"191\":255152,\"254\":255129,\"255\":255156,\"263\":256074,\"286\":255106,\"287\":255132,\"318\":255110,\"319\":255136,\"382\":255114,\"383\":255140,\"414\":255119,\"415\":255145,\"446\":255123,\"447\":255149,\"510\":255128,\"511\":255153}}},\"TEXT_MAP\":{\"WEEK\":{\"0\":254354,\"1\":254355,\"2\":254356,\"3\":254357,\"4\":254358,\"5\":254359,\"6\":254360},\"MONTH\":{\"1\":254361,\"2\":254362,\"3\":254363,\"4\":254364,\"5\":254365,\"6\":254366,\"7\":254367,\"8\":254368,\"9\":254369,\"10\":254370,\"11\":254371,\"12\":254372},\"HOUR\":{\"AM\":254373,\"PM\":254374}},\"TIMEZONE_MAP\":{\"Asia/Shanghai\":254375,\"Asia/Hong_Kong\":254376,\"America/New_York\":254377,\"America/Chicago\":254378,\"Europe/Berlin\":254379,\"Europe/London\":254380,\"Europe/Rome\":254381,\"Asia/Taipei\":254382,\"Asia/Singapore\":254383,\"Europe/Paris\":254384,\"Europe/Amsterdam\":254385,\"Europe/Lisbon\":254386,\"Europe/Brussels\":254387,\"Asia/Seoul\":254388,\"Australia/Sydney\":254389,\"Asia/Tokyo\":254390,\"Asia/Kuala_Lumpur\":254391},\"LANG_PARAM\":{\"LANG_MAP\":{\"0\":0,\"1\":0,\"2\":2,\"5\":5,\"7\":2},\"LOCALE_LANG_CODE\":{\"zh-cn\":0,\"zh-hk\":0,\"en-us\":2,\"ja\":5,\"fr\":2},\"PATH_AREA\":[\"us\",\"sg\",\"cn\",\"hk\",\"au\",\"ca\",\"tw\",\"jp\",\"my\"],\"PATH_LANG\":[\"en\",\"hans\",\"hant\",\"ja\",\"fr\"],\"PATH_LANG_MAP\":{\"en\":2,\"hans\":0,\"hant\":0,\"ja\":5,\"fr\":2},\"SUPPORT_LANG\":[0,1,2,5,7]},\"UK_AREA_LIST\":[]}",
    "1": "-",
    "2": "-",
    "5": "-",
    "7": "-"
  },
  "254979": {
    "0": "TimeZone",
    "1": "TimeZone",
    "2": "TimeZone",
    "5": "TimeZone",
    "7": "TimeZone"
  },
  "254980": {
    "0": "HH",
    "1": "HH",
    "2": "HH",
    "5": "HH",
    "7": "HH"
  },
  "254981": {
    "0": "HourClockHH",
    "1": "HourClockHH",
    "2": "HH HourClock",
    "5": "HourClockHH",
    "7": "HH HourClock"
  },
  "254982": {
    "0": "mm",
    "1": "mm",
    "2": "mm",
    "5": "mm",
    "7": "mm"
  },
  "254983": {
    "0": "ss",
    "1": "ss",
    "2": "ss",
    "5": "ss",
    "7": "ss"
  },
  "254984": {
    "0": "SSS",
    "1": "SSS",
    "2": "SSS",
    "5": "SSS",
    "7": "SSS"
  },
  "254993": {
    "0": "HH:mm (TimeZone)",
    "1": "HH:mm (TimeZone)",
    "2": "HH:mm TimeZone",
    "5": "HH:mm TimeZone",
    "7": "HH:mm TimeZone"
  },
  "254994": {
    "0": "HourClockHH:mm (TimeZone)",
    "1": "HourClockHH:mm (TimeZone)",
    "2": "HH:mm HourClock TimeZone",
    "5": "HourClockHH:mm TimeZone",
    "7": "HH:mm HourClock TimeZone"
  },
  "254995": {
    "0": "HH:mm",
    "1": "HH:mm",
    "2": "HH:mm",
    "5": "HH:mm",
    "7": "HH:mm"
  },
  "254996": {
    "0": "HourClockHH:mm",
    "1": "HourClockHH:mm",
    "2": "HH:mm HourClock",
    "5": "HourClockHH:mm",
    "7": "HH:mm HourClock"
  },
  "254997": {
    "0": "HourClockHH:mm:ss (TimeZone)",
    "1": "HourClockHH:mm:ss (TimeZone)",
    "2": "HH:mm:ss HourClock TimeZone",
    "5": "HourClockHH:mm:ss TimeZone",
    "7": "HH:mm:ss HourClock TimeZone"
  },
  "254998": {
    "0": "HH:mm:ss (TimeZone)",
    "1": "HH:mm:ss (TimeZone)",
    "2": "HH:mm:ss TimeZone",
    "5": "HH:mm:ss TimeZone",
    "7": "HH:mm:ss TimeZone"
  },
  "254999": {
    "0": "HH:mm:ss.SSS (TimeZone)",
    "1": "HH:mm:ss.SSS (TimeZone)",
    "2": "HH:mm:ss.SSS TimeZone",
    "5": "HH:mm:ss.SSS TimeZone",
    "7": "HH:mm:ss.SSS TimeZone"
  },
  "255000": {
    "0": "HourClockHH:mm:ss.SSS (TimeZone)",
    "1": "HourClockHH:mm:ss.SSS (TimeZone)",
    "2": "HH:mm:ss.SSS HourClock TimeZone",
    "5": "HourClockHH:mm:ss.SSS TimeZone",
    "7": "HH:mm:ss.SSS HourClock TimeZone"
  },
  "255001": {
    "0": "HourClockHH:mm:ss.SSS",
    "1": "HourClockHH:mm:ss.SSS",
    "2": "HH:mm:ss.SSS HourClock",
    "5": "HourClockHH:mm:ss.SSS",
    "7": "HH:mm:ss.SSS HourClock"
  },
  "255002": {
    "0": "HH:mm:ss.SSS",
    "1": "HH:mm:ss.SSS",
    "2": "HH:mm:ss.SSS",
    "5": "HH:mm:ss.SSS",
    "7": "HH:mm:ss.SSS"
  },
  "255003": {
    "0": "EEEE",
    "1": "EEEE",
    "2": "EEEE",
    "5": "EEEE",
    "7": "EEEE"
  },
  "255004": {
    "0": "EEEE HH:mm (TimeZone)",
    "1": "EEEE HH:mm (TimeZone)",
    "2": "EEEE, HH:mm TimeZone",
    "5": "EEEE HH:mm TimeZone",
    "7": "EEEE, HH:mm TimeZone"
  },
  "255005": {
    "0": "EEEE HourClockHH:mm (TimeZone)",
    "1": "EEEE HourClockHH:mm (TimeZone)",
    "2": "EEEE, HH:mm HourClock TimeZone",
    "5": "EEEE HourClockHH:mm TimeZone",
    "7": "EEEE, HH:mm HourClock TimeZone"
  },
  "255006": {
    "0": "EEEE HourClockHH:mm",
    "1": "EEEE HourClockHH:mm",
    "2": "EEEE, HH:mm HourClock",
    "5": "EEEE HourClockHH:mm",
    "7": "EEEE, HH:mm HourClock"
  },
  "255007": {
    "0": "EEEE HH:mm",
    "1": "EEEE HH:mm",
    "2": "EEEE, HH:mm",
    "5": "EEEE HH:mm",
    "7": "EEEE, HH:mm"
  },
  "255008": {
    "0": "EEEE HH:mm:ss (TimeZone)",
    "1": "EEEE HH:mm:ss (TimeZone)",
    "2": "EEEE, HH:mm:ss TimeZone",
    "5": "EEEE HH:mm:ss TimeZone",
    "7": "EEEE, HH:mm:ss TimeZone"
  },
  "255009": {
    "0": "EEEE HourClockHH:mm:ss (TimeZone)",
    "1": "EEEE HourClockHH:mm:ss (TimeZone)",
    "2": "EEEE, HH:mm:ss HourClock TimeZone",
    "5": "EEEE HourClockHH:mm:ss TimeZone",
    "7": "EEEE, HH:mm:ss HourClock TimeZone"
  },
  "255010": {
    "0": "EEEE HourClockHH:mm:ss",
    "1": "EEEE HourClockHH:mm:ss",
    "2": "EEEE, HH:mm:ss HourClock",
    "5": "EEEE HourClockHH:mm:ss",
    "7": "EEEE, HH:mm:ss HourClock"
  },
  "255011": {
    "0": "EEEE HH:mm:ss",
    "1": "EEEE HH:mm:ss",
    "2": "EEEE, HH:mm:ss",
    "5": "EEEE HH:mm:ss",
    "7": "EEEE, HH:mm:ss"
  },
  "255012": {
    "0": "EEEE HH:mm:ss.SSS (TimeZone)",
    "1": "EEEE HH:mm:ss.SSS (TimeZone)",
    "2": "EEEE, HH:mm:ss.SSS TimeZone",
    "5": "EEEE HH:mm:ss.SSS TimeZone",
    "7": "EEEE, HH:mm:ss.SSS TimeZone"
  },
  "255013": {
    "0": "EEEE HourClockHH:mm:ss.SSS (TimeZone)",
    "1": "EEEE HourClockHH:mm:ss.SSS (TimeZone)",
    "2": "EEEE, HH:mm:ss.SSS HourClock TimeZone",
    "5": "EEEE HourClockHH:mm:ss.SSS TimeZone",
    "7": "EEEE, HH:mm:ss.SSS HourClock TimeZone"
  },
  "255014": {
    "0": "EEEE HourClockHH:mm:ss.SSS",
    "1": "EEEE HourClockHH:mm:ss.SSS",
    "2": "EEEE, HH:mm:ss.SSS HourClock",
    "5": "EEEE HourClockHH:mm:ss.SSS",
    "7": "EEEE, HH:mm:ss.SSS HourClock"
  },
  "255015": {
    "0": "EEEE HH:mm:ss.SSS",
    "1": "EEEE HH:mm:ss.SSS",
    "2": "EEEE, HH:mm:ss.SSS",
    "5": "EEEE HH:mm:ss.SSS",
    "7": "EEEE, HH:mm:ss.SSS"
  },
  "255016": {
    "0": "YYYY",
    "1": "YYYY",
    "2": "YYYY",
    "5": "YYYY",
    "7": "YYYY"
  },
  "255017": {
    "0": "MMMM",
    "1": "MMMM",
    "2": "MMMM",
    "5": "MMMM",
    "7": "MMMM"
  },
  "255018": {
    "0": "DD",
    "1": "DD",
    "2": "D",
    "5": "DD",
    "7": "D"
  },
  "255019": {
    "0": "YYYY/MMMM",
    "1": "YYYY/MMMM",
    "2": "MMMM YYYY",
    "5": "YYYY/MMMM",
    "7": "MMMM YYYY"
  },
  "255020": {
    "0": "YYYY/MMMM EEEE",
    "1": "YYYY/MMMM EEEE",
    "2": "EEEE, MMMM YYYY",
    "5": "YYYY/MMMM(EEEE)",
    "7": "EEEE, MMMM YYYY"
  },
  "255021": {
    "0": "MMMM/DD",
    "1": "MMMM/DD",
    "2": "MMMM D",
    "5": "MMMM/DD",
    "7": "MMMM D"
  },
  "255022": {
    "0": "MMMM/DD HH:mm (TimeZone)",
    "1": "MMMM/DD HH:mm (TimeZone)",
    "2": "MMMM D HH:mm TimeZone",
    "5": "MMMM/DD HH:mm TimeZone",
    "7": "MMMM D HH:mm TimeZone"
  },
  "255023": {
    "0": "MMMM/DD HourClockHH:mm (TimeZone)",
    "1": "MMMM/DD HourClockHH:mm (TimeZone)",
    "2": "MMMM D HH:mm HourClock TimeZone",
    "5": "MMMM/DD HourClockHH:mm TimeZone",
    "7": "MMMM D HH:mm HourClock TimeZone"
  },
  "255024": {
    "0": "MMMM/DD HourClockHH:mm",
    "1": "MMMM/DD HourClockHH:mm",
    "2": "MMMM D HH:mm HourClock",
    "5": "MMMM/DD HourClockHH:mm",
    "7": "MMMM D HH:mm HourClock"
  },
  "255031": {
    "0": "MMMM/DD HourClockHH:mm:ss (TimeZone)",
    "1": "MMMM/DD HourClockHH:mm:ss (TimeZone)",
    "2": "MMMM D HH:mm:ss HourClock TimeZone",
    "5": "MMMM/DD HourClockHH:mm:ss TimeZone",
    "7": "MMMM D HH:mm:ss HourClock TimeZone"
  },
  "255032": {
    "0": "MMMM/DD HH:mm:ss (TimeZone)",
    "1": "MMMM/DD HH:mm:ss (TimeZone)",
    "2": "MMMM D HH:mm:ss TimeZone",
    "5": "MMMM/DD HH:mm:ss TimeZone",
    "7": "MMMM D HH:mm:ss TimeZone"
  },
  "255035": {
    "0": "MMMM/DD HH:mm:ss",
    "1": "MMMM/DD HH:mm:ss",
    "2": "MMMM D HH:mm:ss",
    "5": "MMMM/DD HH:mm:ss",
    "7": "MMMM D HH:mm:ss"
  },
  "255036": {
    "0": "MMMM/DD HourClockHH:mm:ss",
    "1": "MMMM/DD HourClockHH:mm:ss",
    "2": "MMMM D HH:mm:ss HourClock",
    "5": "MMMM/DD HourClockHH:mm:ss",
    "7": "MMMM D HH:mm:ss HourClock"
  },
  "255037": {
    "0": "MMMM/DD HourClockHH:mm:ss.SSS (TimeZone)",
    "1": "MMMM/DD HourClockHH:mm:ss.SSS (TimeZone)",
    "2": "MMMM D HH:mm:ss.SSS HourClock TimeZone",
    "5": "MMMM/DD HourClockHH:mm:ss.SSS TimeZone",
    "7": "MMMM D HH:mm:ss.SSS HourClock TimeZone"
  },
  "255038": {
    "0": "MMMM/DD HH:mm:ss.SSS (TimeZone)",
    "1": "MMMM/DD HH:mm:ss.SSS (TimeZone)",
    "2": "MMMM D HH:mm:ss.SSS TimeZone",
    "5": "MMMM/DD HH:mm:ss.SSS TimeZone",
    "7": "MMMM D HH:mm:ss.SSS TimeZone"
  },
  "255039": {
    "0": "MMMM/DD HH:mm:ss.SSS",
    "1": "MMMM/DD HH:mm:ss.SSS",
    "2": "MMMM D HH:mm:ss.SSS",
    "5": "MMMM/DD HH:mm:ss.SSS",
    "7": "MMMM D HH:mm:ss.SSS"
  },
  "255040": {
    "0": "MMMM/DD HourClockHH:mm:ss.SSS",
    "1": "MMMM/DD HourClockHH:mm:ss.SSS",
    "2": "MMMM D HH:mm:ss.SSS HourClock",
    "5": "MMMM/DD HourClockHH:mm:ss.SSS",
    "7": "MMMM D HH:mm:ss.SSS HourClock"
  },
  "255041": {
    "0": "MMMM/DD EEEE",
    "1": "MMMM/DD EEEE",
    "2": "EEEE, MMMM D",
    "5": "MMMM/DD(EEEE)",
    "7": "EEEE, MMMM D"
  },
  "255042": {
    "0": "MMMM/DD EEEE HH:mm (TimeZone)",
    "1": "MMMM/DD EEEE HH:mm (TimeZone)",
    "2": "EEEE, MMMM D HH:mm TimeZone",
    "5": "MMMM/DD(EEEE) HH:mm TimeZone",
    "7": "EEEE, MMMM D HH:mm TimeZone"
  },
  "255044": {
    "0": "MMMM/DD EEEE HourClockHH:mm (TimeZone)",
    "1": "MMMM/DD EEEE HourClockHH:mm (TimeZone)",
    "2": "EEEE, MMMM D HH:mm HourClock TimeZone",
    "5": "MMMM/DD(EEEE) HourClockHH:mm TimeZone",
    "7": "EEEE, MMMM D HH:mm HourClock TimeZone"
  },
  "255046": {
    "0": "MMMM/DD EEEE HourClockHH:mm",
    "1": "MMMM/DD EEEE HourClockHH:mm",
    "2": "EEEE, MMMM D HH:mm HourClock",
    "5": "MMMM/DD(EEEE) HourClockHH:mm",
    "7": "EEEE, MMMM D HH:mm HourClock"
  },
  "255048": {
    "0": "MMMM/DD EEEE HH:mm",
    "1": "MMMM/DD EEEE HH:mm",
    "2": "EEEE, MMMM D HH:mm",
    "5": "MMMM/DD(EEEE) HH:mm",
    "7": "EEEE, MMMM D HH:mm"
  },
  "255050": {
    "0": "MMMM/DD EEEE HH:mm:ss (TimeZone)",
    "1": "MMMM/DD EEEE HH:mm:ss (TimeZone)",
    "2": "EEEE, MMMM D HH:mm:ss TimeZone",
    "5": "MMMM/DD(EEEE) HH:mm:ss TimeZone",
    "7": "EEEE, MMMM D HH:mm:ss TimeZone"
  },
  "255051": {
    "0": "MMMM/DD EEEE HourClockHH:mm:ss (TimeZone)",
    "1": "MMMM/DD EEEE HourClockHH:mm:ss (TimeZone)",
    "2": "EEEE, MMMM D HH:mm:ss HourClock TimeZone",
    "5": "MMMM/DD(EEEE) HourClockHH:mm:ss TimeZone",
    "7": "EEEE, MMMM D HH:mm:ss HourClock TimeZone"
  },
  "255053": {
    "0": "MMMM/DD EEEE HourClockHH:mm:ss",
    "1": "MMMM/DD EEEE HourClockHH:mm:ss",
    "2": "EEEE, MMMM D HH:mm:ss HourClock",
    "5": "MMMM/DD(EEEE) HourClockHH:mm:ss",
    "7": "EEEE, MMMM D HH:mm:ss HourClock"
  },
  "255057": {
    "0": "MMMM/DD EEEE HH:mm:ss",
    "1": "MMMM/DD EEEE HH:mm:ss",
    "2": "EEEE, MMMM D HH:mm:ss",
    "5": "MMMM/DD(EEEE) HH:mm:ss",
    "7": "EEEE, MMMM D HH:mm:ss"
  },
  "255061": {
    "0": "MMMM/DD EEEE HH:mm:ss.SSS (TimeZone)",
    "1": "MMMM/DD EEEE HH:mm:ss.SSS (TimeZone)",
    "2": "EEEE, MMMM D HH:mm:ss.SSS TimeZone",
    "5": "MMMM/DD(EEEE) HH:mm:ss.SSS TimeZone",
    "7": "EEEE, MMMM D HH:mm:ss.SSS TimeZone"
  },
  "255063": {
    "0": "MMMM/DD EEEE HourClockHH:mm:ss.SSS (TimeZone)",
    "1": "MMMM/DD EEEE HourClockHH:mm:ss.SSS (TimeZone)",
    "2": "EEEE, MMMM D HH:mm:ss.SSS HourClock TimeZone",
    "5": "MMMM/DD(EEEE) HourClockHH:mm:ss.SSS TimeZone",
    "7": "EEEE, MMMM D HH:mm:ss.SSS HourClock TimeZone"
  },
  "255066": {
    "0": "MMMM/DD EEEE HourClockHH:mm:ss.SSS",
    "1": "MMMM/DD EEEE HourClockHH:mm:ss.SSS",
    "2": "EEEE, MMMM D HH:mm:ss.SSS HourClock",
    "5": "MMMM/DD(EEEE) HourClockHH:mm:ss.SSS",
    "7": "EEEE, MMMM D HH:mm:ss.SSS HourClock"
  },
  "255068": {
    "0": "MMMM/DD EEEE HH:mm:ss.SSS",
    "1": "MMMM/DD EEEE HH:mm:ss.SSS",
    "2": "EEEE, MMMM D HH:mm:ss.SSS",
    "5": "MMMM/DD(EEEE) HH:mm:ss.SSS",
    "7": "EEEE, MMMM D HH:mm:ss.SSS"
  },
  "255070": {
    "0": "YYYY/MMMM/DD HH:mm (TimeZone)",
    "1": "YYYY/MMMM/DD HH:mm (TimeZone)",
    "2": "MMMM D, YYYY HH:mm TimeZone",
    "5": "YYYY/MMMM/DD HH:mm TimeZone",
    "7": "MMMM D, YYYY HH:mm TimeZone"
  },
  "255073": {
    "0": "YYYY/MMMM/DD HourClockHH:mm (TimeZone)",
    "1": "YYYY/MMMM/DD HourClockHH:mm (TimeZone)",
    "2": "MMMM D, YYYY HH:mm HourClock TimeZone",
    "5": "YYYY/MMMM/DD HourClockHH:mm TimeZone",
    "7": "MMMM D, YYYY HH:mm HourClock TimeZone"
  },
  "255076": {
    "0": "YYYY/MMMM/DD HourClockHH:mm",
    "1": "YYYY/MMMM/DD HourClockHH:mm",
    "2": "MMMM D, YYYY HH:mm HourClock",
    "5": "YYYY/MMMM/DD HourClockHH:mm",
    "7": "MMMM D, YYYY HH:mm HourClock"
  },
  "255078": {
    "0": "YYYY/MMMM/DD HH:mm",
    "1": "YYYY/MMMM/DD HH:mm",
    "2": "MMMM D, YYYY HH:mm",
    "5": "YYYY/MMMM/DD HH:mm",
    "7": "MMMM D, YYYY HH:mm"
  },
  "255085": {
    "0": "YYYY/MMMM/DD HH:mm:ss (TimeZone)",
    "1": "YYYY/MMMM/DD HH:mm:ss (TimeZone)",
    "2": "MMMM D, YYYY HH:mm:ss TimeZone",
    "5": "YYYY/MMMM/DD HH:mm:ss TimeZone",
    "7": "MMMM D, YYYY HH:mm:ss TimeZone"
  },
  "255089": {
    "0": "YYYY/MMMM/DD HourClockHH:mm:ss (TimeZone)",
    "1": "YYYY/MMMM/DD HourClockHH:mm:ss (TimeZone)",
    "2": "MMMM D, YYYY HH:mm:ss HourClock TimeZone",
    "5": "YYYY/MMMM/DD HourClockHH:mm:ss TimeZone",
    "7": "MMMM D, YYYY HH:mm:ss HourClock TimeZone"
  },
  "255091": {
    "0": "YYYY/MMMM/DD HourClockHH:mm:ss.SSS (TimeZone)",
    "1": "YYYY/MMMM/DD HourClockHH:mm:ss.SSS (TimeZone)",
    "2": "MMMM D, YYYY HH:mm:ss.SSS HourClock TimeZone",
    "5": "YYYY/MMMM/DD HourClockHH:mm:ss.SSS TimeZone",
    "7": "MMMM D, YYYY HH:mm:ss.SSS HourClock TimeZone"
  },
  "255092": {
    "0": "YYYY/MMMM/DD HH:mm:ss.SSS (TimeZone)",
    "1": "YYYY/MMMM/DD HH:mm:ss.SSS (TimeZone)",
    "2": "MMMM D, YYYY HH:mm:ss.SSS TimeZone",
    "5": "YYYY/MMMM/DD HH:mm:ss.SSS TimeZone",
    "7": "MMMM D, YYYY HH:mm:ss.SSS TimeZone"
  },
  "255093": {
    "0": "YYYY/MMMM/DD HH:mm:ss.SSS",
    "1": "YYYY/MMMM/DD HH:mm:ss.SSS",
    "2": "MMMM D, YYYY HH:mm:ss.SSS",
    "5": "YYYY/MMMM/DD HH:mm:ss.SSS",
    "7": "MMMM D, YYYY HH:mm:ss.SSS"
  },
  "255094": {
    "0": "YYYY/MMMM/DD HourClockHH:mm:ss.SSS",
    "1": "YYYY/MMMM/DD HourClockHH:mm:ss.SSS",
    "2": "MMMM D, YYYY HH:mm:ss.SSS HourClock",
    "5": "YYYY/MMMM/DD HourClockHH:mm:ss.SSS",
    "7": "MMMM D, YYYY HH:mm:ss.SSS HourClock"
  },
  "255095": {
    "0": "YYYY/MMMM/DD EEEE",
    "1": "YYYY/MMMM/DD EEEE",
    "2": "EEEE, MMMM D, YYYY",
    "5": "YYYY/MMMM/DD(EEEE)",
    "7": "EEEE, MMMM D, YYYY"
  },
  "255096": {
    "0": "YYYY/MMMM/DD EEEE HH:mm (TimeZone)",
    "1": "YYYY/MMMM/DD EEEE HH:mm (TimeZone)",
    "2": "EEEE, MMMM D, YYYY HH:mm TimeZone",
    "5": "YYYY/MMMM/DD(EEEE) HH:mm TimeZone",
    "7": "EEEE, MMMM D, YYYY HH:mm TimeZone"
  },
  "255097": {
    "0": "YYYY/MMMM/DD EEEE HourClockHH:mm (TimeZone)",
    "1": "YYYY/MMMM/DD EEEE HourClockHH:mm (TimeZone)",
    "2": "EEEE, MMMM D, YYYY HH:mm HourClock TimeZone",
    "5": "YYYY/MMMM/DD(EEEE) HourClockHH:mm TimeZone",
    "7": "EEEE, MMMM D, YYYY HH:mm HourClock TimeZone"
  },
  "255098": {
    "0": "YYYY/MMMM/DD EEEE HourClockHH:mm",
    "1": "YYYY/MMMM/DD EEEE HourClockHH:mm",
    "2": "EEEE, MMMM D, YYYY HH:mm HourClock",
    "5": "YYYY/MMMM/DD(EEEE) HourClockHH:mm",
    "7": "EEEE, MMMM D, YYYY HH:mm HourClock"
  },
  "255099": {
    "0": "YYYY/MMMM/DD EEEE HH:mm",
    "1": "YYYY/MMMM/DD EEEE HH:mm",
    "2": "EEEE, MMMM D, YYYY HH:mm",
    "5": "YYYY/MMMM/DD(EEEE) HH:mm",
    "7": "EEEE, MMMM D, YYYY HH:mm"
  },
  "255100": {
    "0": "YYYY/MMMM/DD EEEE HH:mm:ss.SSS (TimeZone)",
    "1": "YYYY/MMMM/DD EEEE HH:mm:ss.SSS (TimeZone)",
    "2": "EEEE, MMMM D, YYYY HH:mm:ss.SSS TimeZone",
    "5": "YYYY/MMMM/DD(EEEE) HH:mm:ss.SSS TimeZone",
    "7": "EEEE, MMMM D, YYYY HH:mm:ss.SSS TimeZone"
  },
  "255101": {
    "0": "YYYY/MMMM/DD EEEE HourClockHH:mm:ss.SSS (TimeZone)",
    "1": "YYYY/MMMM/DD EEEE HourClockHH:mm:ss.SSS (TimeZone)",
    "2": "EEEE, MMMM D, YYYY HH:mm:ss.SSS HourClock TimeZone",
    "5": "YYYY/MMMM/DD(EEEE) HourClockHH:mm:ss.SSS TimeZone",
    "7": "EEEE, MMMM D, YYYY HH:mm:ss.SSS HourClock TimeZone"
  },
  "255102": {
    "0": "YYYY/MMMM/DD EEEE HourClockHH:mm:ss.SSS",
    "1": "YYYY/MMMM/DD EEEE HourClockHH:mm:ss.SSS",
    "2": "EEEE, MMMM D, YYYY HH:mm:ss.SSS HourClock",
    "5": "YYYY/MMMM/DD(EEEE) HourClockHH:mm:ss.SSS",
    "7": "EEEE, MMMM D, YYYY HH:mm:ss.SSS HourClock"
  },
  "255103": {
    "0": "YYYY/MMMM/DD EEEE HH:mm:ss.SSS",
    "1": "YYYY/MMMM/DD EEEE HH:mm:ss.SSS",
    "2": "EEEE, MMMM D, YYYY HH:mm:ss.SSS",
    "5": "YYYY/MMMM/DD(EEEE) HH:mm:ss.SSS",
    "7": "EEEE, MMMM D, YYYY HH:mm:ss.SSS"
  },
  "255105": {
    "0": "MMMM/DD",
    "1": "MMMM/DD",
    "2": "D MMMM",
    "5": "MMMM/DD",
    "7": "D MMMM"
  },
  "255106": {
    "0": "MMMM/DD HH:mm TimeZone",
    "1": "MMMM/DD HH:mm TimeZone",
    "2": "D MMMM HH:mm TimeZone",
    "5": "MMMM/DD HH:mm TimeZone",
    "7": "D MMMM HH:mm TimeZone"
  },
  "255107": {
    "0": "MMMM/DD HourClock HH:mm TimeZone",
    "1": "MMMM/DD HourClock HH:mm TimeZone",
    "2": "D MMMM HH:mm HourClock TimeZone",
    "5": "MMMM/DD HourClockHH:mm TimeZone",
    "7": "D MMMM HH:mm HourClock TimeZone"
  },
  "255108": {
    "0": "MMMM/DD HourClock HH:mm",
    "1": "MMMM/DD HourClock HH:mm",
    "2": "D MMMM HH:mm HourClock",
    "5": "MMMM/DD HourClockHH:mm",
    "7": "D MMMM HH:mm HourClock"
  },
  "255109": {
    "0": "MMMM/DD HH:mm",
    "1": "MMMM/DD HH:mm",
    "2": "D MMMM HH:mm",
    "5": "MMMM/DD HH:mm",
    "7": "D MMMM HH:mm"
  },
  "255110": {
    "0": "MMMM/DD HH:mm:ss TimeZone",
    "1": "MMMM/DD HH:mm:ss TimeZone",
    "2": "D MMMM HH:mm:ss TimeZone",
    "5": "MMMM/DD HH:mm:ss TimeZone",
    "7": "D MMMM HH:mm:ss TimeZone"
  },
  "255111": {
    "0": "MMMM/DD HourClock HH:mm:ss TimeZone",
    "1": "MMMM/DD HourClock HH:mm:ss TimeZone",
    "2": "D MMMM HH:mm:ss HourClock TimeZone",
    "5": "MMMM/DD HourClockHH:mm:ss TimeZone",
    "7": "D MMMM HH:mm:ss HourClock TimeZone"
  },
  "255112": {
    "0": "MMMM/DD HourClock HH:mm:ss",
    "1": "MMMM/DD HourClock HH:mm:ss",
    "2": "D MMMM HH:mm:ss HourClock",
    "5": "MMMM/DD HourClockHH:mm:ss",
    "7": "D MMMM HH:mm:ss HourClock"
  },
  "255113": {
    "0": "MMMM/DD HH:mm:ss",
    "1": "MMMM/DD HH:mm:ss",
    "2": "D MMMM HH:mm:ss",
    "5": "MMMM/DD HH:mm:ss",
    "7": "D MMMM HH:mm:ss"
  },
  "255114": {
    "0": "MMMM/DD HH:mm:ss.SSS TimeZone",
    "1": "MMMM/DD HH:mm:ss.SSS TimeZone",
    "2": "D MMMM HH:mm:ss.SSS TimeZone",
    "5": "MMMM/DD HH:mm:ss.SSS TimeZone",
    "7": "D MMMM HH:mm:ss.SSS TimeZone"
  },
  "255115": {
    "0": "MMMM/DD HourClock HH:mm:ss.SSS TimeZone",
    "1": "MMMM/DD HourClock HH:mm:ss.SSS TimeZone",
    "2": "D MMMM HH:mm:ss.SSS HourClock TimeZone",
    "5": "MMMM/DD HourClockHH:mm:ss.SSS TimeZone",
    "7": "D MMMM HH:mm:ss.SSS HourClock TimeZone"
  },
  "255116": {
    "0": "MMMM/DD HourClock HH:mm:ss.SSS",
    "1": "MMMM/DD HourClock HH:mm:ss.SSS",
    "2": "D MMMM HH:mm:ss.SSS HourClock",
    "5": "MMMM/DD HourClockHH:mm:ss.SSS",
    "7": "D MMMM HH:mm:ss.SSS HourClock"
  },
  "255117": {
    "0": "MMMM/DD HH:mm:ss.SSS",
    "1": "MMMM/DD HH:mm:ss.SSS",
    "2": "D MMMM HH:mm:ss.SSS",
    "5": "MMMM/DD HH:mm:ss.SSS",
    "7": "D MMMM HH:mm:ss.SSS"
  },
  "255118": {
    "0": "MMMM/DD EEEE",
    "1": "MMMM/DD EEEE",
    "2": "EEEE, D MMMM",
    "5": "MMMM/DD(EEEE)",
    "7": "EEEE, D MMMM"
  },
  "255119": {
    "0": "MMMM/DD EEEE HH:mm TimeZone",
    "1": "MMMM/DD EEEE HH:mm TimeZone",
    "2": "EEEE, D MMMM HH:mm TimeZone",
    "5": "MMMM/DD(EEEE) HH:mm TimeZone",
    "7": "EEEE, D MMMM HH:mm TimeZone"
  },
  "255120": {
    "0": "MMMM/DD EEEE HourClock HH:mm TimeZone",
    "1": "MMMM/DD EEEE HourClock HH:mm TimeZone",
    "2": "EEEE, D MMMM HH:mm HourClock TimeZone",
    "5": "MMMM/DD(EEEE) HourClockHH:mm TimeZone",
    "7": "EEEE, D MMMM HH:mm HourClock TimeZone"
  },
  "255121": {
    "0": "MMMM/DD EEEE HourClock HH:mm",
    "1": "MMMM/DD EEEE HourClock HH:mm",
    "2": "EEEE, D MMMM HH:mm HourClock",
    "5": "MMMM/DD(EEEE) HourClockHH:mm",
    "7": "EEEE, D MMMM HH:mm HourClock"
  },
  "255122": {
    "0": "MMMM/DD EEEE HH:mm",
    "1": "MMMM/DD EEEE HH:mm",
    "2": "EEEE, D MMMM HH:mm",
    "5": "MMMM/DD(EEEE) HH:mm",
    "7": "EEEE, D MMMM HH:mm"
  },
  "255123": {
    "0": "MMMM/DD EEEE HH:mm:ss TimeZone",
    "1": "MMMM/DD EEEE HH:mm:ss TimeZone",
    "2": "EEEE, D MMMM HH:mm:ss TimeZone",
    "5": "MMMM/DD(EEEE) HH:mm:ss TimeZone",
    "7": "EEEE, D MMMM HH:mm:ss TimeZone"
  },
  "255124": {
    "0": "MMMM/DD EEEE HourClock HH:mm:ss TimeZone",
    "1": "MMMM/DD EEEE HourClock HH:mm:ss TimeZone",
    "2": "EEEE, D MMMM HH:mm:ss HourClock TimeZone",
    "5": "MMMM/DD(EEEE) HourClockHH:mm:ss TimeZone",
    "7": "EEEE, D MMMM HH:mm:ss HourClock TimeZone"
  },
  "255125": {
    "0": "MMMM/DD EEEE HH:mm:ss",
    "1": "MMMM/DD EEEE HH:mm:ss",
    "2": "EEEE, D MMMM HH:mm:ss",
    "5": "MMMM/DD(EEEE) HH:mm:ss",
    "7": "EEEE, D MMMM HH:mm:ss"
  },
  "255126": {
    "0": "MMMM/DD EEEE HourClock HH:mm:ss",
    "1": "MMMM/DD EEEE HourClock HH:mm:ss",
    "2": "EEEE, D MMMM HH:mm:ss HourClock",
    "5": "MMMM/DD(EEEE) HourClockHH:mm:ss",
    "7": "EEEE, D MMMM HH:mm:ss HourClock"
  },
  "255127": {
    "0": "MMMM/DD EEEE HourClock HH:mm:ss.SSS TimeZone",
    "1": "MMMM/DD EEEE HourClock HH:mm:ss.SSS TimeZone",
    "2": "EEEE, D MMMM HH:mm:ss.SSS HourClock TimeZone",
    "5": "MMMM/DD(EEEE) HourClockHH:mm:ss.SSS TimeZone",
    "7": "EEEE, D MMMM HH:mm:ss.SSS HourClock TimeZone"
  },
  "255128": {
    "0": "MMMM/DD EEEE HH:mm:ss.SSS TimeZone",
    "1": "MMMM/DD EEEE HH:mm:ss.SSS TimeZone",
    "2": "EEEE, D MMMM HH:mm:ss.SSS TimeZone",
    "5": "MMMM/DD(EEEE) HH:mm:ss.SSS TimeZone",
    "7": "EEEE, D MMMM HH:mm:ss.SSS TimeZone"
  },
  "255129": {
    "0": "MMMM/DD EEEE HH:mm:ss.SSS",
    "1": "MMMM/DD EEEE HH:mm:ss.SSS",
    "2": "EEEE, D MMMM HH:mm:ss.SSS",
    "5": "MMMM/DD(EEEE) HH:mm:ss.SSS",
    "7": "EEEE, D MMMM HH:mm:ss.SSS"
  },
  "255130": {
    "0": "MMMM/DD EEEE HourClock HH:mm:ss.SSS",
    "1": "MMMM/DD EEEE HourClock HH:mm:ss.SSS",
    "2": "EEEE, D MMMM HH:mm:ss.SSS HourClock",
    "5": "MMMM/DD(EEEE) HourClockHH:mm:ss.SSS",
    "7": "EEEE, D MMMM HH:mm:ss.SSS HourClock"
  },
  "255131": {
    "0": "YYYY/MMMM/DD",
    "1": "YYYY/MMMM/DD",
    "2": "D MMMM, YYYY",
    "5": "YYYY/MMMM/DD\tYYYY/MMMM/DD",
    "7": "D MMMM, YYYY"
  },
  "255132": {
    "0": "YYYY/MMMM/DD HH:mm TimeZone",
    "1": "YYYY/MMMM/DD HH:mm TimeZone",
    "2": "D MMMM, YYYY HH:mm TimeZone",
    "5": "YYYY/MMMM/DD HH:mm TimeZone",
    "7": "D MMMM, YYYY HH:mm TimeZone"
  },
  "255133": {
    "0": "YYYY/MMMM/DD HourClock HH:mm TimeZone",
    "1": "YYYY/MMMM/DD HourClock HH:mm TimeZone",
    "2": "D MMMM, YYYY HH:mm HourClock TimeZone",
    "5": "YYYY/MMMM/DD HourClockHH:mm TimeZone",
    "7": "D MMMM, YYYY HH:mm HourClock TimeZone"
  },
  "255134": {
    "0": "YYYY/MMMM/DD HourClock HH:mm",
    "1": "YYYY/MMMM/DD HourClock HH:mm",
    "2": "D MMMM, YYYY HH:mm HourClock",
    "5": "YYYY/MMMM/DD HourClockHH:mm",
    "7": "D MMMM, YYYY HH:mm HourClock"
  },
  "255135": {
    "0": "YYYY/MMMM/DD HH:mm",
    "1": "YYYY/MMMM/DD HH:mm",
    "2": "D MMMM, YYYY HH:mm",
    "5": "YYYY/MMMM/DD HH:mm",
    "7": "D MMMM, YYYY HH:mm"
  },
  "255136": {
    "0": "YYYY/MMMM/DD HH:mm:ss TimeZone",
    "1": "YYYY/MMMM/DD HH:mm:ss TimeZone",
    "2": "D MMMM, YYYY HH:mm:ss TimeZone",
    "5": "YYYY/MMMM/DD HH:mm:ss TimeZone",
    "7": "D MMMM, YYYY HH:mm:ss TimeZone"
  },
  "255137": {
    "0": "YYYY/MMMM/DD HourClock HH:mm:ss TimeZone",
    "1": "YYYY/MMMM/DD HourClock HH:mm:ss TimeZone",
    "2": "D MMMM, YYYY HH:mm:ss HourClock TimeZone",
    "5": "YYYY/MMMM/DD HourClockHH:mm:ss TimeZone",
    "7": "D MMMM, YYYY HH:mm:ss HourClock TimeZone"
  },
  "255138": {
    "0": "YYYY/MMMM/DD HourClock HH:mm:ss",
    "1": "YYYY/MMMM/DD HourClock HH:mm:ss",
    "2": "D MMMM, YYYY HH:mm:ss HourClock",
    "5": "YYYY/MMMM/DD HourClockHH:mm:ss",
    "7": "D MMMM, YYYY HH:mm:ss HourClock"
  },
  "255139": {
    "0": "YYYY/MMMM/DD HH:mm:ss",
    "1": "YYYY/MMMM/DD HH:mm:ss",
    "2": "D MMMM, YYYY HH:mm:ss",
    "5": "YYYY/MMMM/DD HH:mm:ss",
    "7": "D MMMM, YYYY HH:mm:ss"
  },
  "255140": {
    "0": "YYYY/MMMM/DD HH:mm:ss.SSS TimeZone",
    "1": "YYYY/MMMM/DD HH:mm:ss.SSS TimeZone",
    "2": "D MMMM, YYYY HH:mm:ss.SSS TimeZone",
    "5": "YYYY/MMMM/DD HH:mm:ss.SSS TimeZone",
    "7": "D MMMM, YYYY HH:mm:ss.SSS TimeZone"
  },
  "255141": {
    "0": "YYYY/MMMM/DD HourClock HH:mm:ss.SSS TimeZone",
    "1": "YYYY/MMMM/DD HourClock HH:mm:ss.SSS TimeZone",
    "2": "D MMMM, YYYY HH:mm:ss.SSS HourClock TimeZone",
    "5": "YYYY/MMMM/DD HourClockHH:mm:ss.SSS TimeZone",
    "7": "D MMMM, YYYY HH:mm:ss.SSS HourClock TimeZone"
  },
  "255142": {
    "0": "YYYY/MMMM/DD HourClock HH:mm:ss.SSS",
    "1": "YYYY/MMMM/DD HourClock HH:mm:ss.SSS",
    "2": "D MMMM, YYYY HH:mm:ss.SSS HourClock",
    "5": "YYYY/MMMM/DD HourClockHH:mm:ss.SSS",
    "7": "D MMMM, YYYY HH:mm:ss.SSS HourClock"
  },
  "255143": {
    "0": "YYYY/MMMM/DD HH:mm:ss.SSS",
    "1": "YYYY/MMMM/DD HH:mm:ss.SSS",
    "2": "D MMMM, YYYY HH:mm:ss.SSS",
    "5": "YYYY/MMMM/DD HH:mm:ss.SSS",
    "7": "D MMMM, YYYY HH:mm:ss.SSS"
  },
  "255144": {
    "0": "YYYY/MMMM/DD EEEE",
    "1": "YYYY/MMMM/DD EEEE",
    "2": "EEEE, D MMMM, YYYY",
    "5": "YYYY/MMMM/DD(EEEE)",
    "7": "EEEE, D MMMM, YYYY"
  },
  "255145": {
    "0": "YYYY/MMMM/DD EEEE HH:mm TimeZone",
    "1": "YYYY/MMMM/DD EEEE HH:mm TimeZone",
    "2": "EEEE, D MMMM, YYYY HH:mm TimeZone",
    "5": "YYYY/MMMM/DD(EEEE) HH:mm TimeZone",
    "7": "EEEE, D MMMM, YYYY HH:mm TimeZone"
  },
  "255146": {
    "0": "YYYY/MMMM/DD EEEE HourClock HH:mm TimeZone",
    "1": "YYYY/MMMM/DD EEEE HourClock HH:mm TimeZone",
    "2": "EEEE, D MMMM, YYYY HH:mm HourClock TimeZone",
    "5": "YYYY/MMMM/DD(EEEE) HourClockHH:mm TimeZone",
    "7": "EEEE, D MMMM, YYYY HH:mm HourClock TimeZone"
  },
  "255147": {
    "0": "YYYY/MMMM/DD EEEE HourClock HH:mm",
    "1": "YYYY/MMMM/DD EEEE HourClock HH:mm",
    "2": "EEEE, D MMMM, YYYY HH:mm HourClock",
    "5": "YYYY/MMMM/DD(EEEE) HourClockHH:mm",
    "7": "EEEE, D MMMM, YYYY HH:mm HourClock"
  },
  "255148": {
    "0": "YYYY/MMMM/DD EEEE HH:mm",
    "1": "YYYY/MMMM/DD EEEE HH:mm",
    "2": "EEEE, D MMMM, YYYY HH:mm",
    "5": "YYYY/MMMM/DD(EEEE) HH:mm",
    "7": "EEEE, D MMMM, YYYY HH:mm"
  },
  "255149": {
    "0": "YYYY/MMMM/DD EEEE HH:mm:ss TimeZone",
    "1": "YYYY/MMMM/DD EEEE HH:mm:ss TimeZone",
    "2": "EEEE, D MMMM, YYYY HH:mm:ss TimeZone",
    "5": "YYYY/MMMM/DD(EEEE) HH:mm:ss TimeZone",
    "7": "EEEE, D MMMM, YYYY HH:mm:ss TimeZone"
  },
  "255150": {
    "0": "YYYY/MMMM/DD EEEE HourClock HH:mm:ss TimeZone",
    "1": "YYYY/MMMM/DD EEEE HourClock HH:mm:ss TimeZone",
    "2": "EEEE, D MMMM, YYYY HH:mm:ss HourClock TimeZone",
    "5": "YYYY/MMMM/DD(EEEE) HourClockHH:mm:ss TimeZone",
    "7": "EEEE, D MMMM, YYYY HH:mm:ss HourClock TimeZone"
  },
  "255151": {
    "0": "YYYY/MMMM/DD EEEE HourClock HH:mm:ss",
    "1": "YYYY/MMMM/DD EEEE HourClock HH:mm:ss",
    "2": "EEEE, D MMMM, YYYY HH:mm:ss HourClock",
    "5": "YYYY/MMMM/DD(EEEE) HourClockHH:mm:ss",
    "7": "EEEE, D MMMM, YYYY HH:mm:ss HourClock"
  },
  "255152": {
    "0": "YYYY/MMMM/DD EEEE HH:mm:ss",
    "1": "YYYY/MMMM/DD EEEE HH:mm:ss",
    "2": "EEEE, D MMMM, YYYY HH:mm:ss",
    "5": "YYYY/MMMM/DD(EEEE) HH:mm:ss",
    "7": "EEEE, D MMMM, YYYY HH:mm:ss"
  },
  "255153": {
    "0": "YYYY/MMMM/DD EEEE HH:mm:ss.SSS TimeZone",
    "1": "YYYY/MMMM/DD EEEE HH:mm:ss.SSS TimeZone",
    "2": "EEEE, D MMMM, YYYY HH:mm:ss.SSS TimeZone",
    "5": "YYYY/MMMM/DD(EEEE) HH:mm:ss.SSS TimeZone",
    "7": "EEEE, D MMMM, YYYY HH:mm:ss.SSS TimeZone"
  },
  "255154": {
    "0": "YYYY/MMMM/DD EEEE HourClock HH:mm:ss.SSS TimeZone",
    "1": "YYYY/MMMM/DD EEEE HourClock HH:mm:ss.SSS TimeZone",
    "2": "EEEE, D MMMM, YYYY HH:mm:ss.SSS HourClock TimeZone",
    "5": "YYYY/MMMM/DD(EEEE) HourClockHH:mm:ss.SSS TimeZone",
    "7": "EEEE, D MMMM, YYYY HH:mm:ss.SSS HourClock TimeZone"
  },
  "255155": {
    "0": "YYYY/MMMM/DD EEEE HourClock HH:mm:ss.SSS",
    "1": "YYYY/MMMM/DD EEEE HourClock HH:mm:ss.SSS",
    "2": "EEEE, D MMMM, YYYY HH:mm:ss.SSS HourClock",
    "5": "YYYY/MMMM/DD(EEEE) HourClockHH:mm:ss.SSS",
    "7": "EEEE, D MMMM, YYYY HH:mm:ss.SSS HourClock"
  },
  "255156": {
    "0": "YYYY/MMMM/DD EEEE HH:mm:ss.SSS",
    "1": "YYYY/MMMM/DD EEEE HH:mm:ss.SSS",
    "2": "EEEE, D MMMM, YYYY HH:mm:ss.SSS",
    "5": "YYYY/MMMM/DD(EEEE) HH:mm:ss.SSS",
    "7": "EEEE, D MMMM, YYYY HH:mm:ss.SSS"
  },
  "255825": {
    "0": "MMMM/DD TimeZone",
    "1": "MMMM/DD TimeZone",
    "2": "MMMM D TimeZone",
    "5": "MMMM/DD TimeZone",
    "7": "MMMM D TimeZone"
  },
  "255826": {
    "0": "MMMM/DD TimeZone",
    "1": "MMMM/DD TimeZone",
    "2": "D MMMM TimeZone",
    "5": "MMMM/DD TimeZone",
    "7": "D MMMM TimeZone"
  },
  "256073": {
    "0": "YYYY/MMMM/DD (TimeZone)",
    "1": "YYYY/MMMM/DD (TimeZone)",
    "2": "MMMM D, YYYY TimeZone",
    "5": "YYYY/MMMM/DD TimeZone",
    "7": "MMMM D, YYYY TimeZone"
  },
  "256074": {
    "0": "YYYY/MMMM/DD (TimeZone)",
    "1": "YYYY/MMMM/DD (TimeZone)",
    "2": "D MMMM, YYYY TimeZone",
    "5": "YYYY/MMMM/DD TimeZone",
    "7": "D MMMM, YYYY TimeZone"
  },
  "TEMPLATE_MAP": {
    "US": {
      "12": {
        "1": 255016,
        "2": 255017,
        "3": 255019,
        "4": 255018,
        "6": 255021,
        "7": 254345,
        "8": 254981,
        "16": 254982,
        "24": 254996,
        "30": 255024,
        "31": 255076,
        "32": 254983,
        "56": 254350,
        "62": 255036,
        "63": 254351,
        "64": 254984,
        "120": 255001,
        "126": 255040,
        "127": 255094,
        "128": 255003,
        "131": 255020,
        "134": 255041,
        "135": 255095,
        "152": 255006,
        "158": 255046,
        "159": 255098,
        "184": 255010,
        "190": 255053,
        "191": 254352,
        "248": 255014,
        "254": 255066,
        "255": 255102,
        "256": 254979,
        "262": 255826,
        "280": 254994,
        "286": 255023,
        "287": 255073,
        "312": 254997,
        "318": 255031,
        "319": 255089,
        "376": 255000,
        "382": 255037,
        "383": 255091,
        "408": 255005,
        "414": 255044,
        "415": 255097,
        "440": 255009,
        "446": 255051,
        "447": 254353,
        "504": 255013,
        "510": 255063,
        "511": 255101
      },
      "24": {
        "1": 255016,
        "2": 255017,
        "3": 255019,
        "4": 255018,
        "6": 255021,
        "7": 254345,
        "8": 254980,
        "16": 254982,
        "24": 254995,
        "30": 254454,
        "31": 255078,
        "32": 254983,
        "56": 254346,
        "62": 255035,
        "63": 254347,
        "64": 254984,
        "120": 255002,
        "126": 255039,
        "127": 255093,
        "128": 255003,
        "131": 255020,
        "134": 255041,
        "135": 255095,
        "152": 255007,
        "158": 255048,
        "159": 255099,
        "184": 255011,
        "190": 255057,
        "191": 254348,
        "248": 255015,
        "254": 255068,
        "255": 255103,
        "256": 254979,
        "262": 255825,
        "263": 256073,
        "280": 254993,
        "286": 255022,
        "287": 255070,
        "312": 254998,
        "318": 255032,
        "319": 255085,
        "376": 254999,
        "382": 255038,
        "383": 255092,
        "408": 255004,
        "414": 255042,
        "415": 255096,
        "440": 255008,
        "446": 255050,
        "447": 254349,
        "504": 255012,
        "510": 255061,
        "511": 255100
      }
    },
    "UK": {
      "12": {
        "6": 255105,
        "7": 255131,
        "30": 255108,
        "31": 255134,
        "62": 255112,
        "63": 255138,
        "126": 255116,
        "127": 255142,
        "134": 255118,
        "135": 255144,
        "158": 255121,
        "159": 255147,
        "190": 255126,
        "191": 255151,
        "254": 255130,
        "255": 255155,
        "286": 255107,
        "287": 255133,
        "318": 255111,
        "319": 255137,
        "382": 255115,
        "383": 255141,
        "414": 255120,
        "415": 255146,
        "446": 255124,
        "447": 255150,
        "510": 255127,
        "511": 255154
      },
      "24": {
        "6": 255105,
        "7": 255131,
        "30": 255109,
        "31": 255135,
        "62": 255113,
        "63": 255139,
        "126": 255117,
        "127": 255143,
        "134": 255118,
        "135": 255144,
        "158": 255122,
        "159": 255148,
        "190": 255125,
        "191": 255152,
        "254": 255129,
        "255": 255156,
        "263": 256074,
        "286": 255106,
        "287": 255132,
        "318": 255110,
        "319": 255136,
        "382": 255114,
        "383": 255140,
        "414": 255119,
        "415": 255145,
        "446": 255123,
        "447": 255149,
        "510": 255128,
        "511": 255153
      }
    }
  },
  "TEXT_MAP": {
    "WEEK": {
      "0": 254354,
      "1": 254355,
      "2": 254356,
      "3": 254357,
      "4": 254358,
      "5": 254359,
      "6": 254360
    },
    "MONTH": {
      "1": 254361,
      "2": 254362,
      "3": 254363,
      "4": 254364,
      "5": 254365,
      "6": 254366,
      "7": 254367,
      "8": 254368,
      "9": 254369,
      "10": 254370,
      "11": 254371,
      "12": 254372
    },
    "HOUR": {
      "AM": 254373,
      "PM": 254374
    }
  },
  "TIMEZONE_MAP": {
    "Asia/Shanghai": 254375,
    "Asia/Hong_Kong": 254376,
    "America/New_York": 254377,
    "America/Chicago": 254378,
    "Europe/Berlin": 254379,
    "Europe/London": 254380,
    "Europe/Rome": 254381,
    "Asia/Taipei": 254382,
    "Asia/Singapore": 254383,
    "Europe/Paris": 254384,
    "Europe/Amsterdam": 254385,
    "Europe/Lisbon": 254386,
    "Europe/Brussels": 254387,
    "Asia/Seoul": 254388,
    "Australia/Sydney": 254389,
    "Asia/Tokyo": 254390,
    "Asia/Kuala_Lumpur": 254391
  },
  "LANG_PARAM": {
    "LANG_MAP": {
      "0": 0,
      "1": 0,
      "2": 2,
      "5": 5,
      "7": 2
    },
    "LOCALE_LANG_CODE": {
      "zh-cn": 0,
      "zh-hk": 0,
      "en-us": 2,
      "ja": 5,
      "fr": 2
    },
    "PATH_AREA": ["us", "sg", "cn", "hk", "au", "ca", "tw", "jp", "my"],
    "PATH_LANG": ["en", "hans", "hant", "ja", "fr"],
    "PATH_LANG_MAP": {
      "en": 2,
      "hans": 0,
      "hant": 0,
      "ja": 5,
      "fr": 2
    },
    "SUPPORT_LANG": [0, 1, 2, 5, 7]
  },
  "UK_AREA_LIST": []
});

/***/ }),

/***/ "./src/enum.js":
/*!*********************!*\
  !*** ./src/enum.js ***!
  \*********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CLIENT_HOUR_CLOCK: function() { return /* binding */ CLIENT_HOUR_CLOCK; },
/* harmony export */   DATE_ELEMENT: function() { return /* binding */ DATE_ELEMENT; },
/* harmony export */   ENTITY: function() { return /* binding */ ENTITY; },
/* harmony export */   LANG_CODE: function() { return /* binding */ LANG_CODE; },
/* harmony export */   LANG_PARAM: function() { return /* binding */ LANG_PARAM; },
/* harmony export */   TEMPLATE_HMS: function() { return /* binding */ TEMPLATE_HMS; },
/* harmony export */   TEMPLATE_TIMEZONE: function() { return /* binding */ TEMPLATE_TIMEZONE; },
/* harmony export */   TEMPLATE_WEEK: function() { return /* binding */ TEMPLATE_WEEK; },
/* harmony export */   TEMPLATE_YMD: function() { return /* binding */ TEMPLATE_YMD; },
/* harmony export */   UPDATE_DURATION: function() { return /* binding */ UPDATE_DURATION; }
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// 语言参数
var LANG_CODE = {
  LANG_SC: 0,
  LANG_TC: 1,
  LANG_EN: 2,
  LANG_JA: 5,
  LANG_FR: 7
};
var _LANG_PARAM = {
  // 语言映射
  LANG_MAP: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, LANG_CODE.LANG_SC, LANG_CODE.LANG_SC), LANG_CODE.LANG_TC, LANG_CODE.LANG_SC), LANG_CODE.LANG_EN, LANG_CODE.LANG_EN), LANG_CODE.LANG_JA, LANG_CODE.LANG_JA), LANG_CODE.LANG_FR, LANG_CODE.LANG_EN),
  // locale: 语言
  LOCALE_LANG_CODE: {
    'zh-cn': LANG_CODE.LANG_SC,
    'zh-hk': LANG_CODE.LANG_SC,
    'en-us': LANG_CODE.LANG_EN,
    'ja': LANG_CODE.LANG_JA,
    'fr': LANG_CODE.LANG_EN
  },
  // pathArea
  PATH_AREA: ['us', 'sg', 'cn', 'hk', 'au', 'ca', 'tw', 'jp', 'my'],
  // pathLang
  PATH_LANG: ['en', 'hans', 'hant', 'ja', 'fr'],
  // pathLang: 语言
  PATH_LANG_MAP: {
    'en': LANG_CODE.LANG_EN,
    'hans': LANG_CODE.LANG_SC,
    'hant': LANG_CODE.LANG_SC,
    'ja': LANG_CODE.LANG_JA,
    'fr': LANG_CODE.LANG_EN
  }
};
// 支持的语言，从 LANG_MAP 的 key 中获取
_LANG_PARAM.SUPPORT_LANG = Object.keys(_LANG_PARAM.LANG_MAP).map(function (lang) {
  return +lang;
});
var LANG_PARAM = _LANG_PARAM;

// 日期/时间类型枚举
var DATE_ELEMENT = {
  YEAR: 1 << 0,
  MONTH: 1 << 1,
  DAY: 1 << 2,
  HOUR: 1 << 3,
  MINUTE: 1 << 4,
  SECOND: 1 << 5,
  MILLISECOND: 1 << 6,
  WEEK: 1 << 7,
  TIMEZONE: 1 << 8
};

// 模板：年月日
var TEMPLATE_YMD = {
  // 年
  YEAR: DATE_ELEMENT.YEAR,
  // 月
  MONTH: DATE_ELEMENT.MONTH,
  // 日
  DAY: DATE_ELEMENT.DAY,
  // 年月
  YEAR_MONTH: DATE_ELEMENT.YEAR | DATE_ELEMENT.MONTH,
  // 月日
  MONTH_DAY: DATE_ELEMENT.MONTH | DATE_ELEMENT.DAY,
  // 年月日
  YEAR_MONTH_DAY: DATE_ELEMENT.YEAR | DATE_ELEMENT.MONTH | DATE_ELEMENT.DAY
};
// 模板：时分秒毫秒
var TEMPLATE_HMS = {
  // 时
  HOUR: DATE_ELEMENT.HOUR,
  // 分
  MINUTE: DATE_ELEMENT.MINUTE,
  // 秒
  SECOND: DATE_ELEMENT.SECOND,
  // 毫秒
  MILLISECOND: DATE_ELEMENT.MILLISECOND,
  // 时分
  HOUR_MINUTE: DATE_ELEMENT.HOUR | DATE_ELEMENT.MINUTE,
  // 时分秒
  HOUR_MINUTE_SECOND: DATE_ELEMENT.HOUR | DATE_ELEMENT.MINUTE | DATE_ELEMENT.SECOND,
  // 时分秒毫秒
  HOUR_MINUTE_SECOND_MILLISECOND: DATE_ELEMENT.HOUR | DATE_ELEMENT.MINUTE | DATE_ELEMENT.SECOND | DATE_ELEMENT.MILLISECOND
};

// 模板：星期
var TEMPLATE_WEEK = {
  // 展示星期
  WEEK: DATE_ELEMENT.WEEK
};

// 模板：时区
var TEMPLATE_TIMEZONE = {
  // 展示时区
  TIMEZONE: DATE_ELEMENT.TIMEZONE
};

// 主体
var ENTITY = {
  FUTUNN: 'futunn',
  MOOMOO: 'moomoo'
};

// 小时制 12/24
var CLIENT_HOUR_CLOCK = {
  HOUR_12: 12,
  HOUR_24: 24
};

// node 缓存更新时间 1小时
var UPDATE_DURATION = 60 * 60 * 1000;

/***/ }),

/***/ "./src/web/toolDateFormatter.js":
/*!**************************************!*\
  !*** ./src/web/toolDateFormatter.js ***!
  \**************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ToolDateFormatter; }
/* harmony export */ });
/* harmony import */ var _enum_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../enum.js */ "./src/enum.js");
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common.js */ "./src/common.js");
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils.js */ "./src/web/utils.js");
/* harmony import */ var _defaultConfig_template_config_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../defaultConfig/template-config.js */ "./src/defaultConfig/template-config.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



// 兜底配置

var ToolDateFormatter = /*#__PURE__*/function () {
  /**
  * @isTest {Boolean} 是否拉取测试环境配置
  * @entity {String} （非必填）主体类型，热更新时需要下载cos配置文件，要知道当前的主体类型 static.futunn.com / static.moomoo.com (ENTITY 中的枚举)
  * @return {Object} 返回日期格式化对象
  */
  function ToolDateFormatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, ToolDateFormatter);
    if (!ToolDateFormatter.instance) {
      // 是否读取测试环境多语言/cos
      this.isTest = options.isTest;
      // 主体，用于判断从什么地址读取cos，允许值为 futunn moomoo
      this.entity = options.entity || _enum_js__WEBPACK_IMPORTED_MODULE_0__.ENTITY.FUTUNN;
      this.i18nTemplate = null;
      this.lastUpdateTime = 0;
      this.init();
      ToolDateFormatter.instance = this;
    }
    return ToolDateFormatter.instance;
  }
  _createClass(ToolDateFormatter, [{
    key: "init",
    value: function init() {
      // 异步发送请求更新 localStorage
      (0,_utils_js__WEBPACK_IMPORTED_MODULE_2__.getTemplateConfig)(this);
      // 1. 先从 localStorage 读取配置
      try {
        if (typeof localStorage !== 'undefined') {
          var template = localStorage.getItem('TOOL_DATE_FORMATTER_TEMPLATE');
          if (template) {
            // 2. 读取到时使用 localStorage
            this.i18nTemplate = JSON.parse(template);
          } else {
            // 3. 读取不到时使用兜底配置
            this.i18nTemplate = _defaultConfig_template_config_js__WEBPACK_IMPORTED_MODULE_3__["default"];
          }
        }
      } catch (error) {
        console.error('[init error]: ', error);
        // 异常则使用兜底模板
        this.i18nTemplate = _defaultConfig_template_config_js__WEBPACK_IMPORTED_MODULE_3__["default"];
      }
    }

    /**
    * 1. 时间格式化函数（异步调用方法）
    * @dateTemplateArr {Array} 日期模板数组，决定格式化输出的部分。取值范围为 TEMPLATE_YMD, TEMPLATE_HMS, TEMPLATE_WEEK 中的枚举
    * @timestamps {Number} 毫秒时间戳
    * @lang {Number} 语言代码，确定要输出的语言版本和时间格式，取值为 LANG_CODE 中枚举
    * @timeZone {String} 时区字符串（如 Asia/Shanghai、America/New_York），用于转换日期时间到指定的时区
    * @clientHourClock {Number} 小时制类型，取值为 CLIENT_HOUR_CLOCK 中枚举 12/24
    * @return {string}  异常时返回空字符串
    */
  }, {
    key: "asyncDateFormatByTemplate",
    value: (function () {
      var _asyncDateFormatByTemplate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(options) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              // 参数校验
              (0,_common_js__WEBPACK_IMPORTED_MODULE_1__.optionsValidate)(options);
              // 获取模板配置
              _context.next = 4;
              return (0,_utils_js__WEBPACK_IMPORTED_MODULE_2__.getTemplateConfig)(this);
            case 4:
              return _context.abrupt("return", (0,_common_js__WEBPACK_IMPORTED_MODULE_1__.dateFormatCommon)(options, this.i18nTemplate));
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.error('[asyncDateFormatByTemplate error]: ', _context.t0);
              return _context.abrupt("return", '');
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 7]]);
      }));
      function asyncDateFormatByTemplate(_x) {
        return _asyncDateFormatByTemplate.apply(this, arguments);
      }
      return asyncDateFormatByTemplate;
    }()
    /**
    * 1. 时间格式化函数（同步调用方法）
    * @dateTemplateArr {Array} 日期模板数组，决定格式化输出的部分。取值范围为 TEMPLATE_YMD, TEMPLATE_HMS, TEMPLATE_WEEK 中的枚举
    * @timestamps {Number} 毫秒时间戳
    * @lang {Number} 语言代码，确定要输出的语言版本和时间格式，取值为 LANG_CODE 中枚举
    * @timeZone {String} 时区字符串（如 Asia/Shanghai、America/New_York），用于转换日期时间到指定的时区
    * @clientHourClock {Number} 小时制类型，取值为 CLIENT_HOUR_CLOCK 中枚举 12/24
    * @return {string}  异常时返回空字符串
    */
    )
  }, {
    key: "dateFormatByTemplate",
    value: function dateFormatByTemplate(options) {
      try {
        // 参数校验
        (0,_common_js__WEBPACK_IMPORTED_MODULE_1__.optionsValidate)(options);
        return (0,_common_js__WEBPACK_IMPORTED_MODULE_1__.dateFormatCommon)(options, this.i18nTemplate);
      } catch (error) {
        console.error('[dateFormatByTemplate error]: ', error);
        return '';
      }
    }

    /**
    * 2. 数据列表时间格式化函数（异步调用方法）
    * @dateTemplateArr {Array} 日期模板数组，决定格式化输出的部分。取值范围为 TEMPLATE_YMD, TEMPLATE_HMS, TEMPLATE_WEEK 中的枚举
    * @lang {Number} 语言代码，确定要输出的语言版本和时间格式，取值为 LANG_CODE 中枚举
    * @timeZone {String} 时区字符串（如 Asia/Shanghai、America/New_York），用于转换日期时间到指定的时区
    * @clientHourClock {Number} 小时制类型，取值为 CLIENT_HOUR_CLOCK 中枚举 12/24
    * @dataList {Array} 需要格式化的对象数组
    * @attrNameList {Array} 需要进行日期格式化的属性
    * @return {string}  返回格式化后的对象数组
    */
  }, {
    key: "asyncListDateFormatByTemplate",
    value: (function () {
      var _asyncListDateFormatByTemplate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              // 参数校验
              (0,_common_js__WEBPACK_IMPORTED_MODULE_1__.optionsValidate)(options);
              // 获取模板配置
              _context2.next = 4;
              return (0,_utils_js__WEBPACK_IMPORTED_MODULE_2__.getTemplateConfig)(this);
            case 4:
              return _context2.abrupt("return", (0,_common_js__WEBPACK_IMPORTED_MODULE_1__.listDateFormatCommon)(options, this.i18nTemplate));
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.error('[asyncListDateFormatByTemplate error]: ', _context2.t0);
              return _context2.abrupt("return", options.dataList);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 7]]);
      }));
      function asyncListDateFormatByTemplate(_x2) {
        return _asyncListDateFormatByTemplate.apply(this, arguments);
      }
      return asyncListDateFormatByTemplate;
    }()
    /**
    * 2. 数据列表时间格式化函数（同步调用方法）
    * @dateTemplateArr {Array} 日期模板数组，决定格式化输出的部分。取值范围为 TEMPLATE_YMD, TEMPLATE_HMS, TEMPLATE_WEEK 中的枚举
    * @lang {Number} 语言代码，确定要输出的语言版本和时间格式，取值为 LANG_CODE 中枚举
    * @timeZone {String} 时区字符串（如 Asia/Shanghai、America/New_York），用于转换日期时间到指定的时区
    * @clientHourClock {Number} 小时制类型，取值为 CLIENT_HOUR_CLOCK 中枚举 12/24
    * @dataList {Array} 需要格式化的对象数组
    * @attrNameList {Array} 需要进行日期格式化的属性
    * @return {string}  返回格式化后的对象数组
    */
    )
  }, {
    key: "listDateFormatByTemplate",
    value: function listDateFormatByTemplate(options) {
      try {
        // 参数校验
        (0,_common_js__WEBPACK_IMPORTED_MODULE_1__.optionsValidate)(options);
        // 获取模板配置
        return (0,_common_js__WEBPACK_IMPORTED_MODULE_1__.listDateFormatCommon)(options, this.i18nTemplate);
      } catch (error) {
        console.error('[listDateFormatByTemplate error]: ', error);
        return options.dataList;
      }
    }
  }]);
  return ToolDateFormatter;
}();


/***/ }),

/***/ "./src/web/utils.js":
/*!**************************!*\
  !*** ./src/web/utils.js ***!
  \**************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getTemplateConfig: function() { return /* binding */ getTemplateConfig; }
/* harmony export */ });
/* harmony import */ var _enum_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../enum.js */ "./src/enum.js");
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common.js */ "./src/common.js");
/* harmony import */ var _defaultConfig_template_config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../defaultConfig/template-config.js */ "./src/defaultConfig/template-config.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }



// 兜底配置


// 获取模板配置
var getTemplateConfig = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_this) {
    var domain, envPath, currentHourTimestamp, configUrl, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          if (!_this.locked) {
            _context.next = 4;
            break;
          }
          _context.next = 4;
          return new Promise(function (resovle) {
            var counter = 0;
            var intervalId = setInterval(function () {
              counter++;
              // 锁释放或者计时器次数超过15次时，清除定时器，进程继续
              if (!_this.locked || counter > 15) {
                clearInterval(intervalId);
                resovle();
              }
            }, 200);
          });
        case 4:
          if (!_this.i18nTemplate) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return");
        case 6:
          // 添加锁
          _this.locked = true;
          // 浏览器环境
          domain = _this.entity === _enum_js__WEBPACK_IMPORTED_MODULE_0__.ENTITY.FUTUNN ? _enum_js__WEBPACK_IMPORTED_MODULE_0__.ENTITY.FUTUNN : _enum_js__WEBPACK_IMPORTED_MODULE_0__.ENTITY.MOOMOO;
          envPath = _this.isTest ? 'test' : 'prod'; // 每小时更新一次时间戳
          currentHourTimestamp = (0,_common_js__WEBPACK_IMPORTED_MODULE_1__.getHourlyTimestamp)(); // 正式：https://static.futunn.com/tool-date-format/config/prod/template-config.json?_t=123
          // 测试：https://static.futunn.com/tool-date-format/config/test/template-config.json?_t=123
          configUrl = "https://static.".concat(domain, ".com/tool-date-format/config/").concat(envPath, "/template-config.json?_t=").concat(currentHourTimestamp); // 3s超时，则抛出异常，使用兜底配置
          _context.next = 13;
          return (0,_common_js__WEBPACK_IMPORTED_MODULE_1__.customFetchWithTimeout)(configUrl, 3000);
        case 13:
          response = _context.sent;
          if (response.ok) {
            _context.next = 16;
            break;
          }
          throw new Error("WEB HTTP error! status: ".concat(response.status));
        case 16:
          _context.next = 18;
          return response.json();
        case 18:
          _this.i18nTemplate = _context.sent;
          // 更新 localStorage
          if (typeof localStorage !== 'undefined') {
            localStorage.setItem('TOOL_DATE_FORMATTER_TEMPLATE', JSON.stringify(_this.i18nTemplate));
          }
          _context.next = 26;
          break;
        case 22:
          _context.prev = 22;
          _context.t0 = _context["catch"](0);
          console.error('[web]getTemplateConfig error', _context.t0);
          // 异常则使用兜底配置
          _this.i18nTemplate = _defaultConfig_template_config_js__WEBPACK_IMPORTED_MODULE_2__["default"];
        case 26:
          _context.prev = 26;
          // 释放锁
          _this.locked = false;
          return _context.finish(26);
        case 29:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 22, 26, 29]]);
  }));
  return function getTemplateConfig(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {
/*!**************************!*\
  !*** ./src/web/index.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CLIENT_HOUR_CLOCK: function() { return /* binding */ CLIENT_HOUR_CLOCK; },
/* harmony export */   ENTITY: function() { return /* binding */ ENTITY; },
/* harmony export */   LANG_CODE: function() { return /* binding */ LANG_CODE; },
/* harmony export */   TEMPLATE_HMS: function() { return /* binding */ TEMPLATE_HMS; },
/* harmony export */   TEMPLATE_TIMEZONE: function() { return /* binding */ TEMPLATE_TIMEZONE; },
/* harmony export */   TEMPLATE_WEEK: function() { return /* binding */ TEMPLATE_WEEK; },
/* harmony export */   TEMPLATE_YMD: function() { return /* binding */ TEMPLATE_YMD; },
/* harmony export */   ToolDateFormatter: function() { return /* reexport safe */ _toolDateFormatter_js__WEBPACK_IMPORTED_MODULE_1__["default"]; }
/* harmony export */ });
/* harmony import */ var _enum_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../enum.js */ "./src/enum.js");
/* harmony import */ var _toolDateFormatter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./toolDateFormatter.js */ "./src/web/toolDateFormatter.js");


var TEMPLATE_YMD = _enum_js__WEBPACK_IMPORTED_MODULE_0__.TEMPLATE_YMD;
var TEMPLATE_HMS = _enum_js__WEBPACK_IMPORTED_MODULE_0__.TEMPLATE_HMS;
var TEMPLATE_WEEK = _enum_js__WEBPACK_IMPORTED_MODULE_0__.TEMPLATE_WEEK;
var TEMPLATE_TIMEZONE = _enum_js__WEBPACK_IMPORTED_MODULE_0__.TEMPLATE_TIMEZONE;
var LANG_CODE = _enum_js__WEBPACK_IMPORTED_MODULE_0__.LANG_CODE;
var CLIENT_HOUR_CLOCK = _enum_js__WEBPACK_IMPORTED_MODULE_0__.CLIENT_HOUR_CLOCK;
var ENTITY = _enum_js__WEBPACK_IMPORTED_MODULE_0__.ENTITY;

}();
module.exports = __webpack_exports__;
/******/ })()
;